export const hotBaseUrl =
  process.env.NODE_ENV === "development"
    ? "http://yuhuatai.4dage.com/YHT/Swkk/hotData/"
    : "hotData/";

export const hotData = [
  // 新加的，不在热点列表里面的
  {
    hotId: "ZLZ",
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "1948年赵良璋烈士由南京中央军人监狱致妻子朱铁华的信和信封",
      },
      {
        id: "2.png",
        name: "",
        content: "1948年赵良璋烈士由南京中央军人监狱致妻子朱铁华的信和信封",
      },
    ],
  },
  {
    hotId: "XSY",
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "1948年谢士炎烈士所作狱中诗",
      },
    ],
  },
  {
    hotId: "ZG",
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "1948年周镐烈士的日记",
      },
      {
        id: "2.png",
        name: "",
        content: "1948年周镐烈士的日记",
      },
    ],
  },

  // =========第一部分
  {
    hotId: "K8DvRh0144677",
    img: [
      {
        id: "1.png",
        name: "党的创建和大革命时期江苏省党组织系统表",
        content:
          "中国共产党成立后，中国革命的面貌为之一新。依据党的一大通过的纲领和决议，全国各地党组织迅速开展各项工作。在党的初创时期和大革命时期，江苏是党活动的重要区域。图为党的创建和大革命时期中共中央直属组织分布情况<br/>图为党的创建和大革命时期江苏省党组织系统表",
      },
    ],
  },
  {
    hotId: "ijElNj696011",
    img: [
      {
        id: "1.png",
        name: "金佛庄的毕业证书",
        content: "1922年，金佛庄毕业于保定陆军军官学校。这是该校颁发的毕业证书",
      },
      {
        id: "2.jpg",
        name: "位于广州东山新河浦的春园",
        content:
          "1923年6月，中国共产党第三次代表大会在广州召开，会议决定采取共产党员以个人身份加入国民党的方式实现国共合作。金佛庄作为浙江代表出席了党的三大。图为位于广州东山新河浦的春园，党的三大期间许多重要活动在此举行",
      },
      // {
      //   id: '3.jpg',
      //   name: '金佛庄的任命状',
      //   content: '1924年6月，金佛庄被任命为黄埔军校第一期学生队第三队队长。这是当时的任命状'
      // },
      // {
      //   id: '4.jpg',
      //   name: '金佛庄发表的文章《军官的心理》',
      //   content: '1924年，金佛庄在第一次国共合作时期的理论刊物《新建设》杂志上发表文章《军官的心理》，提出建设新型革命军队的想法'
      // },
      {
        id: "5.png",
        name: "金佛庄所佩的黄埔军校“学”字证章",
        content: "金佛庄所佩的黄埔军校“学”字证章",
      },
      {
        id: "6.jpg",
        name: "金佛庄的任命书",
        content: "黄埔军校颁发给金佛庄的任命书",
      },
      {
        id: "7.jpg",
        name: "金佛庄的委任状",
        content: "黄埔军校颁发给金佛庄的委任状",
      },
      {
        id: "8.jpg",
        name: "金佛庄与郭俊的合影",
        content:
          "金佛庄（左）任国民革命军第一军一师二团团长时与该团党代表、共产党员郭俊的合影",
      },
      {
        id: "9.png",
        name: "金佛庄写的《传略自述》",
        content: "1926年，金佛庄率部东征时写下的《传略自述》",
      },
    ],
  },
  {
    hotId: "cvBGm645925",
    img: [
      {
        id: "1.jpg",
        name: "川南师范学校旧址",
        content:
          "1921年春，张霁帆考入位于四川泸州的川南师范学校读书，在老师恽代英的影响下，走上革命道路。图为该校旧址",
      },
      {
        id: "2.jpg",
        name: "张霁帆与友人合影",
        content: "张霁帆（左）和友人的合影",
      },
      {
        id: "3.png",
        name: "张霁帆在宜宾留省学会会刊上发表的文章",
        content:
          "1923年，张霁帆在成都组织宜宾留省学会，探究改造社会之法。他在该会第一期会刊上发表文章《一个改造社会可能的办法》，阐明救国主张。",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "1925年正月初四张霁帆烈士写给十哥的信",
      },
    ],
  },
  {
    hotId: "vTkxB281259",
    img: [
      {
        id: "1.png",
        name: "东南大学旧址",
        content:
          "东南大学旧址<br/>1927年3月24日，北伐军攻占南京。为纪念成律、吴光田，东南大学师生在校园内建立纪念碑",
      },
      {
        id: "2.png",
        name: "吴光田中学时代的作文",
        content: "吴光田中学时代的作文",
      },
      {
        id: "3.png",
        name: "《申报》刊登的纪念文章",
        content:
          "1927年，上海《申报》刊登的纪念文章《为党牺牲之成律》和成律遗书的部分内容<br/>1927年，上海《申报》刊登的纪念文章《为党国牺牲之吴光田》",
      },
    ],
  },
  {
    hotId: "oiIkrv2646331",
    img: [
      {
        id: "1.jpg",
        name: "津浦铁路浦品站旧址",
        content:
          "1926年，赵文秀担任津浦铁路浦口工务段党支部书记。图为南京浦口站旧址",
      },
    ],
  },
  // =========第二部分
  {
    hotId: "1SmfDrz747562",
    img: [
      {
        id: "1.jpg",
        name: "邓中夏故居",
        content: "湖南宜章邓中夏故居",
      },
      {
        id: "2.png",
        name: "邓中夏中学时画的《醒狮图》",
        content:
          "邓中夏中学时画的《醒狮图》，将中国比喻成一头沉睡的雄狮，寄托他对国民早日觉醒奋起的心愿，表达了强烈的爱国情感",
      },
      {
        id: "3.jpg",
        name: "杨昌济和岳麓书院旧址",
        content:
          "1915年，邓中夏考入湖南高等师范学校（前身为岳麓书院），受教于杨昌济（杨开慧之父），并结识了在湖南第一师范读书、同为杨昌济学生的毛泽东等。图为杨昌济和岳麓书院旧址",
      },
      {
        id: "4.jpg",
        name: "邓中夏在湖南高等师范读书时与友人的合影",
        content: "邓中夏（后排左二）在湖南高等师范读书时与友人的合影",
      },
      {
        id: "5.png",
        name: "北京大学红楼旧址和大学时的邓中夏",
        content:
          "1917年，邓中夏考入北京大学。图为北京大学红楼旧址和大学时的邓中夏",
      },
      {
        id: "6.jpg",
        name: "五四运动场景",
        content:
          "1919年5月4日，北京大学等13所大中专院校的学生3000余人到天安门前集会，强烈要求北京政府拒绝在巴黎和约上签字，五四运动爆发。在这场反帝爱国运动中，邓中夏任北京学生联合会总务干事，参与火烧赵家楼的行动。图为五四运动场景",
      },
      {
        id: "7.png",
        name: "《国民》杂志",
        content:
          "1919年1月，进步学生团体学生救国会创办《国民》杂志，旨在向青年学生进行反帝爱国宣传，邓中夏是主要创办人和撰稿人。这是《国民》杂志第一卷第三号",
      },
      {
        id: "8.jpg",
        name: "平民教育讲演团在街头演讲",
        content:
          "1919年3月，邓中夏等在北京大学发起成立平民教育讲演团，旨在“增进平民智识、唤起平民之自觉心”。邓中夏先后任总务干事、编辑干事，负责实际领导工作。图为讲演团在街头演讲",
      },
      {
        id: "9.jpg",
        name: "少年中国学会部分会员在北京岳云别墅的合影",
        content:
          "1919年7月，王光祈、李大钊等人发起成立少年中国学会，其宗旨是“本科学的精神为社会活动，以创造少年中国”。同月，邓中夏加入少年中国学会，先后任执行部主任、评议员等职务。图为少年中国学会部分会员在北京岳云别墅的合影，邓中夏（左二）、李大钊（右三）、黄日葵（右二）",
      },
      {
        id: "10.jpg",
        name: "邓中夏填写的《少年中国学会改组委员会调查表》",
        content: "1926年1月，邓中夏填写的《少年中国学会改组委员会调查表》",
      },
      {
        id: "11.jpg",
        name: "邓中夏、毛泽东等人在北京陶然亭公园的合影",
        content:
          "1920年1月，邓中夏与毛泽东等人在北京陶然亭公园商讨驱逐湖南军阀张敬尧事宜。图为他们会后在山门外古槐下的合影，邓中夏（左七）、毛泽东（左四）",
      },
      {
        id: "12.jpg",
        name: "北京大学马克思学说研究会部分会员的合影",
        content:
          "1920年3月，在李大钊领导下，邓中夏、高君宇等人发起组织北京大学马克思学说研究会。这是中国最早学习和研究马克思主义的团体，为建党作了重要准备。图为北京大学马克思学说研究会部分会员的合影，邓中夏（后排左七）、何孟雄（左五）、黄日葵（左六）",
      },
      {
        id: "13.jpg",
        name: "亢慕义斋旧址",
        content:
          "北京大学马克思学说研究会成立后，专门建立了办公室和图书馆。图书馆命名为“亢慕义斋”（“亢慕义”是英文“共产主义”的音译）。图为亢慕义斋旧址",
      },
      {
        id: "15.jpg",
        name: "北京大学图书馆李大钊的办公室",
        content:
          "1920年10月，以马克思学说研究会的成员为骨干，李大钊发起组织了北京的共产党早期组织，邓中夏成为中国共产党最早的党员之一。图为北京共产党早期组织所在地北京大学图书馆李大钊的办公室",
      },
      {
        id: "16.jpg",
        name: "长辛店劳动补习学校旧址",
        content:
          "1920年4月起，邓中夏在北京长辛店从事工人运动，主办工人劳动补习学校，建立工会，为北方工人运动培养了大批骨干力量。图为长辛店劳动补习学校旧址",
      },
      // {
      //   id: '17.jpg',
      //   name: '《劳动音》创刊号',
      //   content: '1920年11月，北京共产党早期组织创办《劳动音》，邓中夏任主编，用以指导工人运动。图为《劳动音》创刊号'
      // },
      {
        id: "18.jpg",
        name: "第一次全国劳动大会旧址",
        content:
          "1922年5月1日，邓中夏出席在广州召开的第一次全国劳动大会，当选为中国劳动组合书记部主任。图为第一次全国劳动大会旧址",
      },
      {
        id: "19.png",
        name: "邓中夏领导的工人罢工场景",
        content:
          "1922-1923年，邓中夏相继参与领导了开滦煤矿工人大罢工、京汉铁路工人大罢工，掀起了中国工人运动第一次高潮。图为罢工场景",
      },
      {
        id: "20.jpg",
        name: "领导上海工人运动的邓中夏",
        content:
          "1925年2月，上海日商内外棉第八厂大批工人被厂方无理开除，工人罢工反抗。邓中夏前往负责指导，发展了22家4万多工人参加罢工，成为五卅运动的前奏。图为领导上海工人运动的邓中夏",
      },
      {
        id: "21.jpg",
        name: "中华全国总工会旧址",
        content:
          "1925年5月，第二次全国劳动大会在广州召开，建立了全国统一的工会领导机构中华全国总工会。邓中夏当选为执行委员，任秘书长兼宣传部长。图为中华全国总工会旧址",
      },
      {
        id: "22.jpg",
        name: "省港罢工委员会机关旧址东园",
        content:
          "1925年6月，省港大罢工爆发，邓中夏任罢工委员会中共党团书记，负责处理有关罢工的一切事宜。省港大罢工坚持了16个月，显示了中国工人阶级的伟大力量和奋斗精神，在中国革命史上写下了光辉的一页。图为罢工委员会机关旧址东园",
      },
      {
        id: "23.jpg",
        name: "邓中夏与苏兆征一起研究工作",
        content: "邓中夏（右）与省港罢工委员会委员长苏兆征一起研究工作",
      },
      {
        id: "24.jpg",
        name: "邓中夏、苏兆征与罢工代表交谈",
        content: "邓中夏（左四）、苏兆征（左五）与罢工代表交谈",
      },
      {
        id: "25.jpg",
        name: "邓中夏与纠察委员们的合影",
        content: "邓中夏（左四）与省港罢工委员会所属纠察委员会委员们的合影",
      },
      {
        id: "26.png",
        name: "邓中夏著作《省港罢工概观》",
        content:
          "邓中夏论述省港大罢工的著作《省港罢工概观》《拥护省港罢工》，封面题词和漫画均为邓中夏手迹",
      },
      {
        id: "27.jpg",
        name: "八七会议参加者名单",
        content:
          "1927年8月7日，中共中央在湖北汉口召开紧急会议，总结大革命失败的教训，讨论党的工作任务，确立了实行土地革命和武装起义的方针。邓中夏出席这次会议，并当选为中央临时政治局候补委员。<br/>图为八七会议会址 <br/>邓中夏是参加八七会议的中央委员之一。图为八七会议参加者名单",
      },
      {
        id: "28.jpg",
        name: "党的六大会址",
        content:
          "1928年6月至7月，中国共产党第六次全国代表大会在莫斯科召开，总结过去革命斗争的经验教训，提出反对“左”、右两种错误倾向。邓中夏出席这次大会，并当选为中央候补委员。图为党的六大会址",
      },
      {
        id: "29.jpg",
        name: "邓中夏与妻子、孩子在莫斯科的合影",
        content:
          "1928年，邓中夏赴莫斯科任中华全国总工会驻赤色职工国际代表，这是他与妻子李英、孩子在莫斯科的合影，照片的背后是邓中夏的妻子写的一行俄文：只给无所畏惧的男人",
      },
      {
        id: "30.jpg",
        name: "邓中夏撰写的《中国职工运动简史》",
        content:
          "邓中夏在莫斯科撰写了《中国职工运动简史》，总结了中国早期职工运动的经验，是我国第一部较系统的近代工运史著作。这是不同版本的《中国职工运动简史》",
      },
      {
        id: "31.jpg",
        name: "湘鄂西革命根据地中心湖北洪湖瞿家湾",
        content:
          "1930年，邓中夏任中共湘鄂西特委书记、红二军团政治委员兼前敌委员会书记，与贺龙、周逸群一起领导湘鄂西的武装斗争。图为湘鄂西革命根据地中心湖北洪湖瞿家湾",
      },
      {
        id: "32.jpg",
        name: "邓中夏被捕地点上海环龙路骏德里37号",
        content:
          "1933年5月，邓中夏在上海环龙路骏德里37号与互济总会救援部长研究工作时，不幸被捕。图为被捕地点",
      },
      {
        id: "33.jpg",
        name: "狱中的邓中夏",
        content:
          "被捕后，邓中夏化名施义，他以共产党员的坚定信念和钢铁意志，挺住了敌人金钱厚禄的利诱和严刑拷打的摧残。图为狱中的邓中夏",
      },
      {
        id: "34.jpg",
        name: "毛泽东给邓中夏妻子夏明的信",
        content:
          "邓中夏牺牲后，妻子李英改名夏明。1945年3月1日，毛泽东在写给夏明的信中，鼓励她“继启汉、中夏遗志”。启汉为夏明哥哥李启汉，是我党早期党员，1927年4月被国民党当局杀害",
      },
      {
        id: "35.jpg",
        name: "毛泽东接见邓中夏继母廖彩德",
        content: "1956年，毛泽东接见邓中夏继母廖彩德",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "邓中夏小学时期抄写的课本",
      },
    ],
  },
  {
    hotId: "S8CGSa487858",
    img: [
      {
        id: "1.jpg",
        name: "幼年恽代英与母亲、兄弟的合影",
        content: "幼年恽代英（右二）与母亲、兄弟的合影",
      },
      {
        id: "2.jpg",
        name: "学生时代的恽代英",
        content:
          "恽代英出身书香门第，少年时勤奋好学，因文才出众被老师誉为“奇男儿”。图为学生时代的恽代英",
      },
      {
        id: "3.jpg",
        name: "私立武昌中华大学旧址",
        content:
          "1913 年，恽代英考入武昌中华大学预科。图为私立武昌中华大学旧址",
      },
      {
        id: "4.png",
        name: "恽代英发表的文章《义务论》",
        content:
          "恽代英在大学期间研究哲学、研究社会，探求改造社会、挽救民族危亡的途径。这是他发表的文章《义务论》",
      },
      {
        id: "5.png",
        name: "恽代英日记",
        content: "恽代英在日记中，严格解剖自己的言行，砥砺自己的品质",
      },
      {
        id: "6.png",
        name: "恽代英日记两篇",
        content: "这是恽代英1919年1月1日、26日两篇日记",
      },
      {
        id: "7.jpg",
        name: "1918 年 6 月互助社成员在武昌的合影",
        content:
          "1917 年，恽代英组织成立了武汉地区最早的进步社团互助社，以“群策群力，自助助人”为宗旨，倡导青年担负起救国的责任。图为 1918 年 6 月互助社成员在武昌的合影，恽代英（前排左三）、林育南（前排左四）、刘仁静（前排左六）",
      },
      {
        id: "8.jpg",
        name: "恽代英与家人的合影",
        content:
          "1918年，恽代英（右一）与父亲恽爵三、弟弟恽子强和妹妹恽顺芳的合影",
      },
      {
        id: "9.jpg",
        name: "利群书社旧址",
        content:
          "1920年，恽代英与林育南等人创办利群书社，成为武汉地区传播新思想、新文化的重要阵地。毛泽东曾专程上门观摩学习。图为位于武汉市武昌区横街头18号的利群书社旧址",
      },
      {
        id: "10.png",
        name: "恽代英请人从美国购买图书的明信片",
        content: "恽代英请奚季耕为利群书社从美国购买图书的明信片",
      },
      {
        id: "11.jpg",
        name: "参加少年中国学会第二次年会的部分会员合影",
        content:
          "1921 年7月，在恽代英的提议和筹备下，少年中国学会第二次年会在南京召开。图为部分会员合影，恽代英（前排左二）、刘仁静（前排左三）、杨贤江（前排左四）、高君宇（二排左三）、张闻天（三排左六）、邓中夏（四排左二）",
      },
      {
        id: "12.jpg",
        name: "恽代英著《阶级争斗》",
        content:
          "1920年秋，恽代英受《新青年》杂志委托翻译并出版了卡尔·考茨基的中期著作《阶级争斗》，这本书对毛泽东、周恩来、董必武等确立共产主义信仰产生过深刻影响",
      },
      {
        id: "13.jpg",
        name: "参加中国社会主义青年团第二次代表大会的部分代表合影",
        content:
          "1923 年 8 月，中国社会主义青年团第二次代表大会在南京召开，恽代英当选团中央执行委员会候补委员兼宣传部长。图为部分代表的合影，恽代英（二排左四）、刘仁静（二排左一）、黄日葵（二排左三）、阮啸仙（一排左二）、夏明翰（一排左四）、邓中夏（一排左五）",
      },
      {
        id: "14.jpg",
        name: "《中国青年》编辑部旧址",
        content:
          "1923 年 10 月 20 日，中国社会主义青年团机关刊物《中国青年》（周刊）在上海创刊，恽代英任首任主编。他亲自撰写并发表了一百多篇文章和几十篇通讯，使《中国青年》成为宣传马克思主义和共产党主张、揭露和批判国民党右派的重要阵地，成为青年们最喜爱的进步刊物，培养和影响了一代青年。图为位于上海淡水路 66 弄 4 号的《中国青年》编辑部旧址",
      },
      {
        id: "15.jpg",
        name: "1924 年 5 月国民党上海执行部部分成员在孙中山寓所的合影",
        content:
          "1924年，恽代英与毛泽东、邓中夏、向警予等参加了国共合作的国民党上海执行部的领导工作，担任宣传部秘书。图为1924 年 5 月国民党上海执行部部分成员在孙中山寓所的合影，恽代英（后排右三）、毛泽东（后排左二）、邓中夏（前排左一）、向警予（前排右一）、王荷波（二排右三）",
      },
      {
        id: "16.jpg",
        name: "担任黄埔军校武汉分校政治总教官的恽代英",
        content:
          "1927年1月恽代英到武汉，主持中央军事政治学校（黄埔军校武汉分校）工作，任政治总教官。在恽代英的领导下，武汉中央军事政治学校为中国共产党培养了大批政治军事人才。",
      },
      {
        id: "17.png",
        name: "恽代英编写的黄埔军校教材",
        content: "恽代英编写的黄埔军校教材《政治学概论》《中国民族革命运动史》",
      },
      {
        id: "18.jpg",
        name: "位于武汉市武昌区解放路259号的中央军事政治学校旧址",
        content: "图为位于武汉市武昌区解放路259号的中央军事政治学校旧址",
      },
      {
        id: "19.jpg",
        name: "国民党二届三中全会执行委员会委员合影",
        content:
          "1927年3月10日，国民党二届三中全会在汉口举行。在共产党人及国民党左派的共同努力下，会议免去蒋介石的国民党中常会主席等职务，通过了支持工农运动的决议。图为国民党二届三中全会执行委员会委员合影，恽代英（三排左七）、毛泽东（二排左八）、宋庆龄（前排左六）、董必武（二排左二）、邓演达（三排右三）",
      },
      {
        id: "20.jpg",
        name: "武汉市武昌区都府堤20号的中共五大会址",
        content:
          "在大革命生死存亡的紧急关头，中国共产党于1927年4月在武汉举行第五次全国代表大会。恽代英出席了此次会议，与毛泽东、瞿秋白等人一起对党内的右倾机会主义错误进行抵制和批判。在此次大会上，恽代英当选为中央委员。图为位于武汉市武昌区都府堤20号的党的五大会址",
      },
      {
        id: "21.png",
        name: "《革命生活》专发的《讨蒋特刊》",
        content:
          "四一二反革命政变后，恽代英主编的《革命生活》专发的《讨蒋特刊》",
      },
      {
        id: "22.jpg",
        name: "南昌起义总指挥部旧址——原江西大旅社",
        content:
          "1927年8月1日凌晨，在以周恩来为书记，李立三、恽代英、彭湃为委员的中共中央前敌委员会领导下，南昌起义爆发。南昌起义打响了武装反抗国民党反动派的第一枪，标志着中国共产党独立领导武装斗争、创建人民军队的开始。图为南昌起义总指挥部旧址——原江西大旅社",
      },
      {
        id: "23.jpg",
        name: "恽代英主编的中共中央机关刊物《红旗》",
        content: "恽代英主编的中共中央机关刊物《红旗》和他在该刊上发表的文章",
      },
      {
        id: "24.jpg",
        name: "中共中央组织部旧址",
        content:
          "1929年末，恽代英调任中共中央组织部秘书长，成为部长周恩来的得力助手。图为位于上海北成都路丽云坊（今成都北路741弄54号）的中共中央组织部旧址",
      },
      {
        id: "25.jpg",
        name: "恽代英被捕地点老怡和纱厂旧址",
        content:
          "1930年5月6日，恽代英前往上海杨树浦韬明路（今通北路）的老怡和纱厂联络工作时，突遇英国巡捕拦路搜查，被搜出革命传单，因此被捕。图为恽代英被捕地点老怡和纱厂旧址",
      },
      {
        id: "26.jpg",
        name: "国民党中央军人监狱旧址",
        content:
          "1931年2月，恽代英被转押到南京，关押在国民党中央军人监狱。图为监狱旧址",
      },
      {
        id: "27.jpg",
        name: "1953年周恩来亲笔录写的恽代英狱中诗",
        content:
          "1931年2月，恽代英从狱中党支部得知龙华24烈士殉难的消息，其中有他早年志同道合、情同手足的林育南、李求实等。为纪念死去的战友，也为表达自己视死如归的决心，写下了七言绝句：“浪迹江湖数旧游，故人生死各千秋。已摈忧患寻常事，留得豪情作楚囚”。图为1953年周恩来亲笔录写的恽代英狱中诗",
      },
      {
        id: "28.png",
        name: "恽代英烈士殉难处及恽代英烈士雕像",
        content:
          "恽代英在狱中始终坚贞不屈，严词拒绝国民党的劝降。1931年4月29日，英勇牺牲于监狱刑场。图为恽代英烈士殉难处及恽代英烈士雕像",
      },
      {
        id: "29.png",
        name: "人民出版社出版的《恽代英全集》",
        content:
          "恽代英短暂的36年生命历程中，在从事繁忙的革命工作的同时，还留下了近300万字的遗著。这是人民出版社出版的《恽代英全集》，思想深邃，内容丰富，展现了恽代英在哲学、政治、经济、军事、文化、教育等各个领域丰硕的理论研究成果",
      },
    ],
    "2d": [
      {
        id: "1.jpg",
        name: "",
        content: "恽代英烈士主编的《中国青年周刊》",
      },
    ],
  },
  {
    hotId: "qTvSYb162698",
    img: [
      {
        id: "1.jpg",
        name: "施滉和唯真学会部分成员在清华学校的合影",
        content:
          "五四运动后，爱国、民主思想在清华学校中活跃起来。怀着救国救民、追求真理的满腔热情，施滉等进步学生坚持“真理所在即趋附之”，组织了唯真学会，宗旨是“本互助和奋斗的精神，研究学术，改良社会，以求人类底真幸福”，施滉被推选为会长。图为1920年施滉（前排右三）和唯真学会部分成员在清华学校的合影",
      },
      {
        id: "2.jpg",
        name: "施滉和清华学校学生会学生法庭成员的合影",
        content:
          "1923年秋，施滉被选为清华学校学生会会长。图为施滉（后排左一）与清华学校学生会学生法庭成员的合影",
      },
      {
        id: "3.png",
        name: "徐永煐撰写的《见孙中山先生记》",
        content:
          "1924年1月，施滉和同学徐永煐、何永佶代表唯真学会到广州拜访孙中山，探寻改造社会的正确途径。这是施滉同学徐永煐撰写的《见孙中山先生记》",
      },
      {
        id: "4.jpg",
        name: "《清华周刊》第一八五期",
        content:
          "施滉担任清华学校学生会会长期间，负责主编学生刊物《清华周刊》的《国情报告》专栏。这是《清华周刊》第一八五期",
      },
      {
        id: "5.jpg",
        name: "施滉寄给母亲的照片",
        content: "1923年6月，施滉寄给母亲的照片，背面是他的题字",
      },
      {
        id: "6.jpg",
        name: "施滉与妻子罗静宜在美国的合影",
        content:
          "1923年春，由施滉组织，在唯真学会成员内成立了8人组成的秘密核心组织“超桃”，宗旨是政治救国，以政治途径改造社会。图为施滉与同为“超桃”成员的妻子罗静宜在美国的合影",
      },
      {
        id: "7.png",
        name: "美国斯坦福大学校园",
        content:
          "1924年，施滉赴美国斯坦福大学学习东方史。图为美国斯坦福大学校园",
      },
      {
        id: "8.jpg",
        name: "施滉在美国斯坦福大学与校友的合影",
        content:
          "1926年，施滉（三排左四）在美国斯坦福大学与校友的合影，照片右下角是他的英文题字",
      },
      {
        id: "9.jpg",
        name: "斯坦福大学的毕业纪念册",
        content: "斯坦福大学的毕业纪念册，左下角为施滉",
      },
      {
        id: "10.jpg",
        name: "施滉担任美国共产党中国局书记期间写的工作汇报",
        content:
          "1929年，施滉担任美国共产党中国局书记期间，写给中共中央驻莫斯科代表团的工作汇报，报告了美国共产党中国支部召开第二次代表大会情况及党员组成",
      },
      {
        id: "11.jpg",
        name: "施滉在莫斯科时的留影",
        content:
          "1929年，施滉受党组织派遣到莫斯科学习，并担任少年共产国际翻译。图为施滉在莫斯科时的留影",
      },
      {
        id: "12.png",
        name: "施滉在莫斯科学习时填写的登记表",
        content: "1929年5月，施滉在莫斯科学习时填写的登记表",
      },
      {
        id: "13.png",
        name: "施滉给中共代表团写的信",
        content:
          "1928年底，施滉曾前往古巴，在华侨中建立党的组织。1929年施滉到达莫斯科后，得知他在古巴发展的党员因参加革命活动被驱逐出境，给中共代表团写了这封信，希望接收他们到莫斯科学习",
      },
      {
        id: "14.jpg",
        name: "清华校友为施滉所建的汉白玉纪念壁碑",
        content: "1949年4月29日，清华校友为施滉所建的汉白玉纪念壁碑",
      },
    ],
  },
  {
    hotId: "391rR636307",
    img: [
      {
        id: "1.png",
        name: "少年时的许包野与叔叔、弟弟、堂弟的合影",
        content:
          "7岁时，许包野随父母从泰国回归故乡，在家乡接受启蒙教育。图为少年时的许包野（左二）与叔叔（左三）、弟弟（左一）、堂弟的合影",
      },
      {
        id: "2.png",
        name: "许包野青少年时读过的《陶渊明诗话》《增批古文观止》等书籍",
        content: "许包野青少年时期读过的《陶渊明诗话》《增批古文观止》等书籍",
      },
      {
        id: "3.png",
        name: "法国里昂大学旧址",
        content:
          "1919 年冬，许包野报考蔡元培组织的赴法勤工俭学，以优异成绩被录取。1920 年 4 月，他辞别故乡，到法国里昂大学学习哲学。图为法国里昂大学旧址",
      },
      {
        id: "4.png",
        name: "德国哥廷根市格奥尔格·奥古斯特大学旧址",
        content:
          "1921年，许包野转入德国哥廷根市格奥尔格·奥古斯特大学就读，继续攻读哲学。图为该校旧址",
      },
      {
        id: "5.jpg",
        name: "许包野与朱德等人在德国哥廷根的合影",
        content:
          "1923年，许包野在德国经朱德介绍加入中国共产党。图为1923年10月许包野（后排右二）与朱德（前排右三）等人在德国哥廷根的合影",
      },
      {
        id: "6.png",
        name: "许包野在莫斯科填写的登记表",
        content:
          "1926年，许包野被党组织派往苏联莫斯科东方大学任教。图为1927年许包野在莫斯科填写的登记表，显示他通晓俄、英、法、德等国语言",
      },
      {
        id: "7.jpg",
        name: "许包野妻子叶雁苹写给广东澄海党史办的信",
        content: "1982年，许包野的妻子叶雁苹写给广东澄海党史办的信",
      },
      {
        id: "8.jpg",
        name: "许包野战友谢飞写的证明材料",
        content:
          "1985年11月，许包野战友谢飞（女）写的证明材料，介绍了许包野的牺牲情况",
      },
      {
        id: "9.png",
        name: "许包野从莫斯科带回的床单",
        content: "1985年，叶雁苹临终前捐赠的许包野从莫斯科带回的床单",
      },
      {
        id: "10.png",
        name: "中共汕头市委党史办《关于追认许包野同志为革命烈士的报告》",
        content:
          "1986年，中共汕头市委党史办《关于追认许包野同志为革命烈士的报告》",
      },
      // {
      //   id: '11.jpg',
      //   name: '许包野在法国读书期间写给父母的信',
      //   content: '1920年，许包野在法国读书期间写给父母的信，信中提及希望转学到德国'
      // },
    ],
  },
  {
    hotId: "Rv1QX647839",
    img: [
      {
        id: "1.png",
        name: "吴振鹏在上海大学写给陈原道的信",
        content:
          "1925年，吴振鹏从安徽省立第一师范学校毕业，党组织安排他赴上海大学深造，上海大学是大革命时期国共合作创办的一所培养革命人才的学校。这是1925年8月吴振鹏在上海大学写给陈原道的信",
      },
      {
        id: "2.jpg",
        name: "吴振鹏亲手绘制的《红灯》周刊封面",
        content:
          "1927年5月，吴振鹏在主持共青团江西区委工作的同时，主编共青团江西区委机关刊物《红灯》周刊，他在《红灯》中多次著文抨击蒋介石的反革命行径。这是吴振鹏亲手绘制的《红灯》周刊封面",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "吴振鹏：不灭的“红灯”",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "吴振鹏：不灭的“红灯”",
      },
    ],
  },
  {
    hotId: "GNC8B174677",
    img: [
      {
        id: "1.png",
        name: "陈原道在安徽读书时使用过的名片",
        content:
          "1919年，陈原道考入安徽省立第二甲种农业学校。这是陈原道在该校读书时使用过的名片",
      },
      // {
      //   id: '2.png',
      //   name: '陈原道在安徽读书期间写下的作文',
      //   content: '陈原道在安徽省立第二甲种农业学校读书期间，正值五四运动席卷全国，在聆听了恽代英、萧楚女等人充满爱国激情的演讲后，陈原道写下这篇作文'
      // },
      {
        id: "3.png",
        name: "陈原道在安徽读书期间聆听恽代英演讲时做的笔记",
        content:
          "陈原道在安徽省立第二甲种农业学校读书期间聆听恽代英演讲时做的笔记",
      },
      {
        id: "4.png",
        name: "陈原道的中华全国学生联合会会议出席证和他保存的团刊",
        content:
          "1925年6月，陈原道被芜湖各校学生推选出席在上海召开的中华全国学生联合会第七次代表大会。这是他的会议出席证和他保存的团刊",
      },
      {
        id: "5.jpg",
        name: "莫斯科中山大学旧址",
        content:
          "为纪念孙中山先生，帮助中国国民革命培养干部，1925年10月，苏联在莫斯科建立孙中山劳动大学（简称中山大学）。国共双方选出310名首批学员，陈原道是其中之一。图为位于莫斯科沃尔洪卡大街的中山大学旧址",
      },
      {
        id: "6.png",
        name: "陈原道在莫斯科中山大学时阅读的部分书籍",
        content: "陈原道在莫斯科中山大学时阅读的部分书籍",
      },
      {
        id: "7.png",
        name: "陈原道填写的《旅莫中国国民党支部党员调查表》",
        content:
          "在第一次国共合作的背景下，赴苏留学的陈原道填写的《旅莫中国国民党支部党员调查表》",
      },
      {
        id: "8.png",
        name: "陈原道关于河南问题致中共中央政治局并转共产国际的信",
        content:
          "1930年2月，在中共河南省委连续遭到严重破坏的危难之际，陈原道临危受命，担负起恢复组建河南省委的重任，任河南省委组织部长兼秘书长。这是陈原道关于河南问题致中共中央政治局并转共产国际的信",
      },
      {
        id: "9.jpg",
        name: "《大美晚报》刊登的陈原道被捕后被引渡的消息",
        content:
          "1933年1月，陈原道在上海租界组织和领导工人运动时不幸被捕。这是1933年《大美晚报》刊登的陈原道被捕后被引渡的消息",
      },
      {
        id: "10.jpg",
        name: "《红色中华》关于中华苏维埃共和国第二次代表大会的报道",
        content:
          "1934年，中华苏维埃共和国召开第二次代表大会，毛泽东在开幕词中提议，向在革命斗争中牺牲的恽代英、蔡和森、陈原道等人默哀。这是《红色中华》对此次大会的报道",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content:
          "1925年6月，陈原道被芜湖各校学生推选出席在上海召开的中华全国学生联合会第七次代表大会。这是他的会议出席证和他保存的团刊",
      },
    ],
  },
  {
    hotId: "NB1dz649415",
    img: [
      {
        id: "1.jpg",
        name: "杨峻德在北京中国大学读书时与同学的合影",
        content: "1926年，杨峻德（右五）在北京中国大学读书时与同学的合影",
      },
      {
        id: "2.jpg",
        name: "中共福建建瓯支部旧址",
        content:
          "1926年7月，杨峻德参与创建了闽北第一个党组织中共建瓯支部，并任宣传委员。图为中共福建建瓯支部旧址建瓯市城关大甲巷7号",
      },
      {
        id: "3.jpg",
        name: "闽北红军整编建军的纲领性文件",
        content:
          "1928年1月，杨峻德为建立闽北红军独立团起草的文件《红军之意义》《红军之组织》，是闽北红军整编建军的纲领性文件",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "杨峻德：闽北播火",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "杨峻德：闽北播火",
      },
    ],
  },
  {
    hotId: "MDgHUP649301",
    img: [
      {
        id: "1.jpg",
        name: "黄励与莫斯科中山大学部分师生合影",
        content:
          "1925年10月黄励被党组织派往莫斯科中山大学学习。图为1926年黄励（中坐者二排右二）与莫斯科中山大学部分师生合影",
      },
      {
        id: "2.jpg",
        name: "黄励与丈夫杨放之在莫斯科郊外的合影",
        content:
          "黄励与丈夫杨放之（新中国成立后曾任国务院副秘书长）在莫斯科郊外的合影",
      },
      {
        id: "3.jpg",
        name: "中共江苏省委为营救黄励发出的紧急通知",
        content:
          "1933年4月黄励被捕后，中共江苏省委于5月发出了营救黄励的紧急通知。通知指出，“她在被捕后勇敢坚决，在法庭上怒斥敌人和叛徒，不愧是中国革命斗争的领袖。”这是中共江苏省委发出的紧急通知",
      },
    ],
  },
  {
    hotId: "uDI8n649620",
    img: [
      {
        id: "1.jpg",
        name: "李得钊中学时期与老师、同学的合影",
        content:
          "1920年，李得钊（左二）在温州瓯海艺文中学读书时与老师、同学的合影",
      },
      {
        id: "2.jpg",
        name: "李得钊与父亲李立勋、儿子李海燕在上海的合影",
        content:
          "1933年，李得钊在中共上海中央局秘书处工作。图为李得钊与父亲李立勋、儿子李海燕在上海的合影",
      },
    ],
    "2d": [
      {
        id: "1.jpg",
        name: "",
        content: "李得钊烈士写的狱中诗“烦闷”手稿",
      },
    ],
  },
  {
    hotId: "pugxCL650028",
    img: [
      {
        id: "1.jpg",
        name: "中共江南省委给中央政治局的报告",
        content:
          "1930年12月，中共江南省委向中央政治局报告提请批准蒋云等7人为新的中共江南省委常委。这是给中央政治局的报告",
      },
    ],
  },
  {
    hotId: "sdPYPf648100",
    img: [
      {
        id: "1.png",
        name: "中学堂彩笔习画贴甲编",
        content: "中学堂彩笔习画贴甲编",
      },
      {
        id: "2.jpg",
        name: "上海大学旧址",
        content:
          "1926年初，党组织选送杨振铎去上海大学学习，在校期间任上海大学共青团支部书记，领导上海大学青年运动。图为上海大学旧址",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "杨振铎：“生死在所不计”",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "杨振铎：“生死在所不计”",
      },
    ],
  },
  {
    hotId: "Y8bKC650468",
    img: [
      {
        id: "1.png",
        name: "李治邦中学时用的油灯",
        content: "李治邦中学时用的油灯",
      },
      {
        id: "2.png",
        name: "李治邦中学时用的马灯",
        content: "李治邦中学时用的马灯",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "李治邦：勇敢的好儿郎",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "李治邦：勇敢的好儿郎",
      },
    ],
  },
  {
    hotId: "knbpb674962",
    img: [
      {
        id: "1.png",
        name: "谭寿林中学时期写的作文",
        content: "谭寿林在广西贵县中学读书时写的作文《丈夫当以功济四海论》",
      },
      {
        id: "2.png",
        name: "谭寿林在学校的习问簿",
        content: "谭寿林在学校的习问簿",
      },
      {
        id: "3.png",
        name: "谭寿林在贵县中学读书时的成绩单",
        content: "谭寿林在贵县中学读书时的成绩单",
      },
      {
        id: "4.jpg",
        name: "中共梧州地委旧址",
        content:
          "1925年冬，谭寿林被党组织派回广西工作，并担任中共梧州地委首任书记。图为广西第一个党委机关中共梧州地委旧址",
      },
      {
        id: "5.jpg",
        name: "谭寿林与《民国日报》编辑部人员的合影",
        content:
          "谭寿林在担任梧州地委书记期间，以梧州《民国日报》社社长的公开身份，广泛宣传马克思主义。图为谭寿林（前排左二）与《民国日报》编辑部人员的合影",
      },
      {
        id: "6.jpg",
        name: "谭寿林自传体中篇小说《俘虏的生还》",
        content:
          "1929年，谭寿林将自己的斗争经历写成自传体中篇小说《俘虏的生还》，并以笔名谭勉予发表，书中的主人翁阿曼原型就是谭寿林本人",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content:
          "谭寿林在北京大学读书时和黄日葵等在京的广西籍师生出版的《桂光》半月刊，以呼吁救国和改造社会为宗旨，公开介绍马克思主义的基本观点和无产阶级革命的主张",
      },
    ],
  },
  {
    hotId: "x4PlMu196739",
    img: [
      {
        id: "1.jpg",
        name: "冷少农故居",
        content: "冷少农故居",
      },
      {
        id: "2.png",
        name: "国民政府军政部旧址",
        content:
          "大革命失败后，作为中共中央军委系统秘密党员，冷少农于1928年秋先后打入南京国民政府训练总监部、军政部任秘书，主要为我党领导的武装斗争获取军事情报，对中央革命根据地和红军一、二、三次反“围剿”斗争的胜利作出了突出贡献。图为国民政府军政部旧址",
      },
      {
        id: "3.jpg",
        name: "冷少农写给母亲的信",
        content: "冷少农1930年3月32日写给母亲的信",
      },
      {
        id: "4.jpg",
        name: "冷少农写给儿子的信",
        content: "1932年冷少农在南京写给儿子的信",
      },
      {
        id: "5.jpg",
        name: "冷少农家人合影",
        content:
          "冷少农家人合影，冷少农母亲宋德惠（前排右一）、妻子商娴贞（前排左一）、儿子冷德昌（后排右一）",
      },
    ],
  },
  {
    hotId: "ScGTag338793",
    img: [
      {
        id: "1.jpg",
        name: "何宝珍与母亲的合影",
        content: "何宝珍与母亲的合影",
      },
      {
        id: "2.jpg",
        name: "《第三女师范风潮之两面观》的报道",
        content:
          "1918年，何宝珍考取衡阳湖南省立第三女子师范学校，在学校积极参加学生运动，1922年加入中国社会主义青年团，同年9月因领导学潮被校方开除。图为当时报纸上《第三女师范风潮之两面观》的报道",
      },
      {
        id: "3.jpg",
        name: "清水塘毛泽东旧居",
        content:
          "在湖南长沙清水塘毛泽东与杨开慧的家里，何宝珍初识刘少奇。图为清水塘毛泽东旧居",
      },
      {
        id: "4.jpg",
        name: "安源路矿工人俱乐部子弟学校教职员合影",
        content:
          "1923年，何宝珍到安源路矿工人俱乐部子弟学校任教员兼工人俱乐部书报科委员。4月，何宝珍与刘少奇结为革命伴侣。图为该校教职员合影，何宝珍（二排坐者右三）、刘少奇（三排立者右二）",
      },
      {
        id: "5.png",
        name: "何宝珍发表的《向左转的德意志国会选举》",
        content:
          "1928年7月，何宝珍在《东方杂志》上发表的文章《向左转的德意志国会选举》",
      },
      {
        id: "6.jpg",
        name: "何宝珍在狱中用竹筷磨制的缝衣针",
        content:
          "何宝珍在狱中用竹筷磨制的缝衣针，用来替难友缝补受刑后破烂的衣服",
      },
      {
        id: "7.jpg",
        name: "刘少奇与长子刘允斌、女儿刘爱琴等在延安的合影",
        content:
          "何宝珍牺牲后，留下三个孩子。1938年5月31日《新华日报》登载的刘少奇寻女启事，以及刘少奇（左三）与长子刘允斌（左一）、女儿刘爱琴（左四）等在延安的合影",
      },
    ],
  },
  {
    hotId: "xEwwx4194793",
    img: [
      {
        id: "1.jpg",
        name: "中共韶山特别支部旧址",
        content:
          "1925年6月，中国共产党韶山特别支部成立，这是我党在湖南农村建立的最早的基层组织之一。图为中共韶山特别支部旧址",
      },
      {
        id: "2.jpg",
        name: "毛泽东与毛福轩妻子贺菊英及乡亲们的合影",
        content:
          "1959年6月，毛泽东回到湖南湘潭韶山故乡，与毛福轩妻子贺菊英（前排左五）及乡亲们的合影",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "毛福轩：跟随毛泽东干革命",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "毛福轩：跟随毛泽东干革命",
      },
    ],
  },
  {
    hotId: "A4BptLF661612",
    img: [
      {
        id: "1.jpg",
        name: "洪灵菲在流亡中写给妻子的信",
        content: "洪灵菲在流亡中写给妻子秦静的信",
      },
      {
        id: "2.png",
        name: "洪灵菲创作、翻译的部分文学作品",
        content:
          "洪灵菲长期从事革命文学的创作，著有《流亡》《归家》《转变》等长篇小说。这是洪灵菲创作、翻译的部分文学作品",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content:
          "1927年冬，洪灵菲回到上海，在严酷的白色恐怖中从事党的秘密工作。图为1929年洪灵菲在上海与妻子秦静、儿子的合影",
      },
    ],
  },
  {
    hotId: "RVk69661608",
    img: [
      {
        id: "1.png",
        name: "陈处泰在校时读过的英文版《资本论》",
        content:
          "陈处泰在安徽大学读书期间，积极研习马克思主义，参与发起和组织了马克思主义研究会。这是陈处泰在校时读过的英文版《资本论》",
      },
      {
        id: "2.jpg",
        name: "上海新亚酒楼旧址",
        content: "1935年11月，陈处泰在上海新亚酒楼被捕。图为新亚酒楼旧址",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "陈处泰：为革命而生，为革命而死",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "陈处泰：为革命而生，为革命而死",
      },
    ],
  },

  {
    hotId: "PSrOFr7448910",
    img: [
      {
        id: "1.jpg",
        name: "朱杏南故居",
        content: "位于江苏江阴夏港镇的朱杏南故居，当年曾为党的秘密活动地点",
      },
      {
        id: "2.jpg",
        name: "朱杏南在狱中写给妻子的信",
        content: "1929年9月，朱杏南被捕入狱。这是他在狱中写给妻子的信",
      },
    ],
  },

  {
    hotId: "igk8T661581",
    img: [
      {
        id: "1.jpg",
        name: "中共长淮特委机关旧址",
        content:
          "1930年10月成立的中共长淮特委，领导蚌埠及周围10多个县党的工作。图为中共长淮特委机关旧址蚌埠市二马路寿昌里10号",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "朱务平为培养工会骨干亲手刻印的授课讲义",
      },
    ],
  },

  {
    hotId: "TMsa9663483",
    img: [
      {
        id: "1.jpg",
        name: "张炽留给妻子的照片",
        content:
          "1923年3月，张炽离开家乡、外出求学。这是他留给妻子的照片，背面有临别赠言",
      },
      {
        id: "2.png",
        name: "张炽写给父母的信",
        content: "1923年，张炽写给父母的信",
      },
      {
        id: "3.jpg",
        name: "大连地委写给北方区委肯定张炽工作的报告",
        content:
          "1926年5月，张炽作为中共北方区委特派员前往大连开展党的工作，担任中共大连地委宣传部长。这是1926年6月大连地委写给北方区委的报告，里面充分肯定和高度评价了张炽的工作",
      },
      {
        id: "4.jpg",
        name: "张炽写给妻子的信",
        content: "1930年，张炽在上海任中共中央机关巡视员时写给妻子的信",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "张炽：立志走革命的大路",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "张炽：立志走革命的大路",
      },
    ],
  },
  {
    hotId: "zCbe4N647340",
    img: [
      {
        id: "1.png",
        name: "狱中的汪裕先在其妻送来的母女合照背后题写的两首诗",
        content: "1934年2月，狱中的汪裕先在其妻送来的母女合照背后题写的两首诗",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "1932年，汪裕先在狱中写给姐姐的信",
      },
    ],
  },
  {
    hotId: "6mPum664388",
    img: [
      {
        id: "1.jpg",
        name: "徐全直在校期间与同学合影",
        content:
          "1918年，徐全直考入湖北省立女子师范学校。图为徐全直（左立一）在校期间与同学合影",
      },
      {
        id: "2.png",
        name: "徐全直与陈潭秋武昌旧居",
        content:
          "1925年，徐全直与陈潭秋在武昌高师附小从事革命活动时，结为革命伴侣。图为陈潭秋、夫妇二人武昌旧居",
      },
      {
        id: "3.jpg",
        name: "徐全直与儿子陈鹄、战友戚元德的合影",
        content:
          "1929年秋，徐全直在上海中共中央机关做地下交通联络工作。图为1931年徐全直（中）与儿子陈鹄、战友戚元德的合影",
      },
      {
        id: "4.jpg",
        name: "徐全直和家人的合影",
        content: "徐全直（左二）和家人的合影",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "徐全直：“把自己的生命贡献给党”",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "徐全直：“把自己的生命贡献给党”",
      },
    ],
  },

  {
    hotId: "aCU63T458325",
    img: [
      {
        id: "1.jpg",
        name: "郭纲琳与堂姐的合影",
        content: "郭纲琳出身富裕家庭，图为郭纲琳（右）与堂姐的合影",
      },
      {
        id: "2.jpg",
        name: "郭纲琳女扮男装与嫂嫂的合影",
        content: "郭纲琳（左）女扮男装与嫂嫂的合影",
      },
      {
        id: "3.jpg",
        name: "《大美晚报》关于郭纲琳在法庭上的报道",
        content: "上海《大美晚报》关于郭纲琳在法庭上的报道",
      },
      {
        id: "4.png",
        name: "李丰平纪念郭纲琳的雨花石",
        content: "郭纲琳战友、原浙江省委书记李丰平纪念郭纲琳的雨花石",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content:
          "1934年5月，郭纲琳被押解到南京模范监狱。被关押期间，郭纲琳联合狱中一批共产党员开展斗争，并亲自组织与领导了两次绝食。这是郭纲琳在狱中给哥哥的复信",
      },
    ],
  },

  {
    hotId: "eacHyY455042",
    img: [
      {
        id: "1.jpg",
        name: "乐于泓为纪念丁香创作的木刻版画图",
        content: "1941年，乐于泓为纪念丁香创作的木刻版画图",
      },
      {
        id: "2.png",
        name: "乐于泓所写的日记",
        content:
          "1985年乐于泓所写的日记，其中LAC、 LILAC、Rio Lilac均为丁香的英文名",
      },
      {
        id: "3.jpg",
        name: "乐于泓和女儿、外孙在丁香树前的合影",
        content:
          "1982年，在丁香牺牲50周年的纪念日，乐于泓在亲人陪同下来到雨花台，在丁香就义的地方，亲手种下了一棵丁香树。图为1989年乐于泓和女儿、外孙在丁香树前的合影",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content:
          "1932年，丁香与乐于泓结婚后在上海家中的留影，身后钢琴上是乐于泓的艺术照",
      },
    ],
  },

  {
    hotId: "1wgYvEZ653047",
    img: [
      {
        id: "1.jpg",
        name: "谢文锦故居",
        content: "浙江永嘉谢文锦故居",
      },
      {
        id: "2.jpg",
        name: "浙江省立第一师范学校校足球队合影",
        content:
          "在浙江省立第一师范学校读书期间，谢文锦担任校友会足球部干事。图为校足球队合影，谢文锦（前排右一）",
      },
      {
        id: "3.jpg",
        name: "浙江岩头高等小学旧址",
        content:
          "1918年，谢文锦担任浙江岩头高等小学校长，他努力宣传新思想、新文化。图为岩头高等小学旧址",
      },
      {
        id: "4.jpg",
        name: "上海外国语学社旧址",
        content:
          "1920年9月，上海的共产党早期组织创办了外国语学社，吸收全国各地的青年入学，学习外语和马克思主义基本知识，同时参加一些革命活动。谢文锦与刘少奇、萧劲光等人曾在此学习，他们也成为第一批前往莫斯科留学的青年革命骨干。图为外国语学社旧址上海市新渔阳里6号",
      },
      {
        id: "5.jpg",
        name: "谢文锦学习期间与同学的合影",
        content:
          "谢文锦在上海外国语学社学习期间与同学的合影，谢文锦（后排右）、罗亦农（前排左）、俞秀松（后排中）",
      },
      {
        id: "6.jpg",
        name: "中共温州独立支部旧址",
        content:
          "1924年秋，谢文锦奉中共中央指示回到家乡，创建了浙南地区最早的党组织中共温州独立支部。图为中共温州独立支部旧址",
      },
      {
        id: "7.png",
        name: "谢文锦介绍加入社会主义青年团的报告",
        content: "1924年，谢文锦在浙南温州介绍8人加入社会主义青年团的报告",
      },
      {
        id: "8.jpg",
        name: "谢文锦等人被捕地点大纱帽巷10号",
        content:
          "1927年4月10日夜，中共南京地委，国民党省、市党部，市总工会负责人召开紧急会议，研究应对蒋介石发动反革命政变的措施，由于事泄，谢文锦等10人被国民党反动派便衣队逮捕，史称南京“四一〇”事件，这是上海四一二反革命政变的序幕。图为谢文锦等人被捕地点大纱帽巷10号",
      },
      {
        id: "9.png",
        name: "南京通济门外九龙桥旧址",
        content:
          "国民党反动派将谢文锦等人残忍杀害后，将遗体从九龙桥上抛入秦淮河中。图为南京通济门外九龙桥旧址",
      },
      {
        id: "10.jpg",
        name: "汉口《民国日报》刊登的关于南京“四一〇”反革命事件的书面报告",
        content:
          "这是1927年4月24日汉口《民国日报》刊登的刘少猷关于南京“四一〇”反革命事件的书面报告。该报告披露了中共南京党组织第一次遭受破坏的经过",
      },
      {
        id: "11.jpg",
        name: "中共中央机关刊物上刊登的《悼赵世炎陈延年及其他死于国民党刽子手的同志》",
        content:
          "1927年10月24日，中共中央机关刊物《布尔什维克》第一期扉页上刊登的《悼赵世炎陈延年及其他死于国民党刽子手的同志》",
      },
    ],
  },

  {
    hotId: "41mA7b665339",
    img: [
      {
        id: "1.jpg",
        name: "南洋公学旧址",
        content:
          "1918年，侯绍裘考入上海工业专门学校（前身为上海南洋公学）土木工程系。图为南洋公学旧址",
      },
      {
        id: "2.jpg",
        name: "侯绍裘与省党部部分成员的合影",
        content:
          "1925年8月，国共合作的国民党江苏省党部在上海正式成立，柳亚子、朱季恂、侯绍裘等人任常务委员。图为侯绍裘（右八）与省党部部分成员的合影",
      },
      {
        id: "3.jpg",
        name: "1927年上海特别市临时政府委员会委员合影",
        content:
          "上海第三次武装起义期间，侯绍裘任上海特别市临时政府委员会委员。图为1927年春委员会委员们的合影，侯绍裘（后排左二）、罗亦农（前排左三）",
      },
      {
        id: "4.jpg",
        name: "南京安徽公学旧址",
        content:
          "1927年4月，侯绍裘率国民党江苏省党部赴南京筹建江苏省政府。图为国民党江苏省、南京市党部办公地点南京安徽公学",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "1921年侯绍裘烈士在景贤女中绘制的水彩画",
      },
    ],
  },
  {
    hotId: "fVXYjr675939",
    img: [
      {
        id: "1.png",
        name: "张应春中学时写的日记",
        content:
          "张应春中学时写的日记，表达了关心时局，渴望国家兴旺、人民自由的心愿",
      },
      {
        id: "2.jpg",
        name: "张应春读书时的生活照",
        content: "张应春读书时的生活照",
      },
      {
        id: "3.jpg",
        name: "张应春在校期间与同学的合影",
        content:
          "1922年，张应春从上海女子体育专门学校毕业，先后任教厦门厦岭学校、松江景贤女子中学。图为张应春（左一）在校期间与同学的合影",
      },
      {
        id: "4.jpg",
        name: "中国国民党第二次全国代表大会江苏代表合影",
        content:
          "1926年1月，张应春作为江苏代表，出席了在广州召开的中国国民党第二次全国代表大会。图为出席会议的江苏代表合影，张应春（二排左五）、侯绍裘（二排左三）、刘重民（二排左一）",
      },
      {
        id: "5.jpg",
        name: "张应春执旗率女同胞参加游行场景",
        content:
          "1926年3月12日，南京举行纪念孙中山先生逝世一周年大会，张应春在纪念会上演讲，会后率女同胞们参加游行。图为游行场景，执旗者为张应春",
      },
    ],
  },

  {
    hotId: "JVNrNT666683",
    img: [
      {
        id: "1.jpg",
        name: "南京公共体育场旧址",
        content:
          "1927年4月10日上午，南京各界群众约10万人在公共体育场参加“肃清反革命派”大会，组织了请愿示威游行。刘重民是这次大会和请愿示威游行的组织者和领导者之一。图为南京公共体育场旧址",
      },
    ],
  },

  {
    hotId: "gUwYkn666499",
    img: [
      {
        id: "1.png",
        name: "上海《民国日报》副刊《觉悟》上刊登的《悟悟社宣言书》",
        content:
          "1924年5月，许金元创办青年文学社团悟悟社，并出版《悟悟》杂志。这是上海《民国日报》副刊《觉悟》上刊登的《悟悟社宣言书》",
      },
    ],
  },

  {
    hotId: "i4DCA0667250",
    img: [
      {
        id: "1.png",
        name: "陈君起学生时代读过的书籍《史记》",
        content: "陈君起学生时代读过的书籍《史记》",
      },
      {
        id: "2.png",
        name: "陈君起学生时代读过的书籍《古文翼》",
        content: "陈君起学生时代读过的书籍《古文翼》",
      },
      {
        id: "3.png",
        name: "陈君起的毕业证书",
        content: "1907年12月，陈君起毕业于上海务本女子学校。这是她的毕业证书",
      },
      {
        id: "4.jpg",
        name: "陈君起在南京任小学教师时的照片",
        content: "陈君起在南京任小学教师时的照片",
      },
      {
        id: "5.jpg",
        name: "陈君起的全家合影",
        content: "陈君起的全家合影",
      },
      {
        id: "6.jpg",
        name: "陈君起住址居安里20号",
        content:
          "陈君起入党后，她的家成为中共南京地委机关驻地之一，恽代英、萧楚女等人都曾来此指导南京的革命斗争。图为陈君起住址居安里20号",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "陈君起烈士狱中绘制的“瘦梅虽老”水彩画",
      },
    ],
  },
  {
    hotId: "B1qBxb667267",
    img: [
      {
        id: "1.jpg",
        name: "钟天樾的成绩单",
        content: "1924年，钟天樾考入东南大学。这是他的成绩单",
      },
    ],
  },
  {
    hotId: "i4pVyu681009",
    img: [
      {
        id: "1.jpg",
        name: "上海工人第三次武装起义场景",
        content:
          "1927年3月，孙津川带领上海铁路工人参加了上海工人第三次武装起义。图为上海工人第三次武装起义场景",
      },
    ],
  },
  {
    hotId: "8Gl6V9668316",
    img: [
      {
        id: "1.png",
        name: "史砚芬在狱中写的散文诗",
        content: "史砚芬在狱中写的散文诗",
      },
      {
        id: "2.jpg",
        name: "史砚芬留给弟弟妹妹的诀别信",
        content: "这是史砚芬牺牲后，亲属从他的血衣中发现的留给弟弟妹妹的诀别信",
      },
    ],
  },
  {
    hotId: "g4QGxv689872",
    img: [
      {
        id: "1.png",
        name: "贺瑞麟在狱中写给姐夫袁立超的信",
        content: "1928年中秋，贺瑞麟在狱中写给姐夫袁立超的信",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content:
          "1928年9月28日至10月5日临刑前一周，贺瑞麟在狱中写的《死前日记》",
      },
      {
        id: "2.png",
        name: "",
        content: "贺瑞麟烈士在狱中写的“给父母的告别信”手稿",
      },
      {
        id: "3.png",
        name: "",
        content:
          "在小说《离散》最后一页上，贺瑞麟精心画了一颗五角星，星内写了“雨花台”三个字，表达了他慷慨赴难的决心",
      },
    ],
  },
  {
    hotId: "vjF6iu668220",
    img: [
      {
        id: "1.jpg",
        name: "京汉铁路总工会旧址",
        content:
          "1923年2月1日，京汉铁路总工会在郑州成立，姚佐唐任工会代表，参加了京汉铁路工人大罢工。图为京汉铁路总工会旧址",
      },
      {
        id: "2.jpg",
        name: "姚佐唐在京汉铁路工作时使用的铁锤",
        content: "1923年，姚佐唐在京汉铁路工作时使用的铁锤",
      },
      {
        id: "3.jpg",
        name: "姚佐唐与王荷波、罗章龙在苏联列宁格勒的合影",
        content:
          "1924年6月至7月，赤色职工国际第三次代表大会在莫斯科召开，姚佐唐出席会议并发言。图为姚佐唐（左）与王荷波（中）、罗章龙（右）在苏联列宁格勒的合影",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "姚佐唐：江苏首个党支部书记",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "姚佐唐：江苏首个党支部书记",
      },
    ],
  },
  {
    hotId: "P4uYVB670147",
    img: [
      {
        id: "1.jpg",
        name: "黄瑞生与友人的合影",
        content: "1929年，黄瑞生（坐者左一）与友人的合影",
      },
      {
        id: "2.png",
        name: "国民党对黄瑞生的刑事判决书",
        content:
          "1929年5月，黄瑞生被捕后，国民党判处他一年零六个月徒刑。他在狱中坚持斗争，后被敌人杀害。这是对他的刑事判决书",
      },
    ],
  },
  {
    hotId: "PMjnaq832380",
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "李济：“替代已牺牲的同志”",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "李济：“替代已牺牲的同志”",
      },
    ],
  },
  {
    hotId: "93WcIT698919",
    img: [
      {
        id: "1.jpg",
        name: "夏雨初在北京中国大学读书时与友人的合影",
        content: "夏雨初（第一排中间者）在北京中国大学读书时与友人的合影",
      },
    ],
  },
  {
    hotId: "0o3Ra6700959",
    img: [
      {
        id: "1.png",
        name: "李耘生穿过的马褂",
        content: "李耘生穿过的马褂",
      },
      {
        id: "2.jpg",
        name: "南京贫儿教养院旧址",
        content:
          "1931年，李耘生以历史教员的公开身份活动，秘密恢复南京党的组织，并在南京贫儿教养院新建立了地下党支部。图为该院旧址",
      },
      {
        id: "3.png",
        name: "1931年李耘生与妻子、儿子在南京的合影",
        content:
          "1926年冬，李耘生被派往武汉，任中共硚口特区区委书记，结识了区委组织部长兼妇女部长章蕴，两人结为革命伴侣。图为1931年李耘生与妻子、儿子在南京的合影",
      },
      {
        id: "4.jpg",
        name: "李耘生被捕地点游府西街",
        content:
          "1932年4月，中共南京党组织第七次遭到破坏，李耘生冒着随时被捕的危险，留在南京处理善后工作，不幸被捕。图为被捕地点游府西街",
      },
      {
        id: "5.png",
        name: "章蕴来雨花台凭吊李耘生留影以及写下的纪念诗文",
        content:
          "1982年，李耘生牺牲50周年之际，章蕴来雨花台凭吊留影以及写下的纪念诗文",
      },
    ],
  },
  {
    hotId: "EOwXpk701647",
    img: [
      {
        id: "1.jpg",
        name: "顾衡参加进步学生社团成员在川沙开会时的合影",
        content:
          "顾衡在大学期间参加进步学生社团大地社，探求救国道路。图为社团成员在川沙开会时的合影，顾衡（后坐右一）",
      },
      {
        id: "2.png",
        name: "胡乔木回忆顾衡在北平工作情况的亲笔信",
        content:
          "1931年夏，胡乔木与顾衡在北平工作期间相识。这是1990年5月，胡乔木回忆顾衡在北平工作情况的亲笔信",
      },
      {
        id: "3.png",
        name: "顾衡父亲顾述之写下的《哭衡儿诗》和《祭衡儿文》",
        content:
          "顾衡的父亲顾述之得知儿子牺牲后，悲痛欲绝，写下100首《哭衡儿诗》和《祭衡儿文》",
      },
    ],
  },
  {
    hotId: "N4nZqS675048",
    img: [
      {
        id: "1.png",
        name: "齐国庆的毕业证书",
        content: "1922年6月，齐国庆毕业于安徽省第六中学。这是他的毕业证书",
      },
      {
        id: "2.jpg",
        name: "中央大学旧址",
        content: "中央大学旧址",
      },
    ],
  },
  {
    hotId: "9RqSNw676274",
    img: [
      {
        id: "1.jpg",
        name: "南京秀山公园旧址",
        content:
          "王崇典任中共南京市委委员后，积极发展党的组织，经常在秀山公园召集党团员开会。图为南京秀山公园旧址",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "王崇典——点燃革命的“烈焰”",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "王崇典——点燃革命的“烈焰”",
      },
    ],
  },
  {
    hotId: "nLgGK5x747370",
    img: [
      {
        id: "1.jpg",
        name: "陈景星读过的书籍《四书集注》",
        content: "陈景星读过的书籍《四书集注》",
      },
      {
        id: "2.jpg",
        name: "陈景星读过的书籍《孟子精华》",
        content: "陈景星读过的书籍《孟子精华》",
      },
      {
        id: "3.jpg",
        name: "陈景星读过的书籍《左传菁华录》",
        content: "陈景星读过的书籍《左传菁华录》",
      },
      {
        id: "4.png",
        name: "陈景星读书时用过的墨盒",
        content:
          "1927年，陈景星考入沈阳奉天省立第三高级中学。这是他在该校读书时用过的墨盒",
      },
      {
        id: "5.jpg",
        name: "陈景星读书期间送老师赴法国留学时的合影",
        content:
          "陈景星（前排左三）在沈阳奉天省立第三高级中学读书时送老师赴法国留学时的合影",
      },
      {
        id: "6.png",
        name: "1930年的《金陵大学青年会手册》",
        content:
          "1929年7月，陈景星考入金陵大学。这是1930年的《金陵大学青年会手册》，载有陈景星的家庭住址",
      },
    ],
  },
  {
    hotId: "bpWvcK748130",
    img: [
      {
        id: "1.jpg",
        name: "石璞与三个哥哥的合影",
        content: "石璞（右一）与三个哥哥的合影",
      },
      {
        id: "2.jpg",
        name: "金陵大学旧址",
        content: "1929年7月，石璞考入金陵大学。图为金陵大学旧址",
      },
      {
        id: "3.jpg",
        name: "金陵大学党支部成员的合影",
        content:
          "1929年，金陵大学党支部成员的合影，陈景星（左坐第一人），石璞（右立第一人）",
      },
      {
        id: "4.jpg",
        name: "石璞三哥石瑛在其墓前的留影",
        content:
          "石璞是家中最小的孩子，他牺牲后，家人不断寻找其墓地。1964年初，他的三哥石瑛第三次来到雨花台，终于寻找到了石璞之墓。图为石瑛在墓前的留影",
      },
      {
        id: "5.jpg",
        name: "石璞三哥石瑛在《人民日报》上发表的《三访雨花台》",
        content:
          "1964年5月23日，石瑛在《人民日报》上发表《三访雨花台》，记述了寻找石璞之墓的经过",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "1929年7月4日石璞烈士报考金陵大学的履历书",
      },
    ],
  },
  {
    hotId: "jSkSx677091",
    img: [
      {
        id: "1.jpg",
        name: "江苏省立第三师范学校旧址",
        content:
          "1921年，黄祥宾考入无锡江苏省立第三师范学校，这里也是黄祥宾革命生涯的起点。图为该校旧址",
      },
      {
        id: "2.png",
        name: "黄祥宾在校时的作文",
        content: "黄祥宾在无锡江苏省立第三师范学校时的作文",
      },
      {
        id: "3.jpg",
        name: "黄祥宾与友人的合影",
        content: "黄祥宾（中坐者）与友人的合影",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "黄祥宾：“怕牺牲的不是真革命”",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "黄祥宾：“怕牺牲的不是真革命”",
      },
    ],
  },
  {
    hotId: "HhgcN49678515",
    img: [
      {
        id: "1.jpg",
        name: "1923年上海大学探美画会师生合影",
        content:
          "1923年上海大学探美画会师生合影，师集贤（三排右二）、校长于右任（前排中）",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "1927年师集贤烈士画的梅花水墨画、“江南春色”水墨淡彩画",
      },
    ],
  },
  {
    hotId: "dqU5qU678803",
    img: [
      {
        id: "1.jpg",
        name: "刘雪亮在北平读书时的照片",
        content: "刘雪亮在北平读书时的照片",
      },
    ],
  },
  {
    hotId: "BEdT1679363",
    img: [
      {
        id: "1.jpg",
        name: "陈朝海与家人的合影",
        content: "1928年，陈朝海（前左一）与家人的合影",
      },
      {
        id: "2.jpg",
        name: "陈朝海发表的文章《革命青年应该打破的不良观念》",
        content:
          "1981年广西博白县党史资料《南流》转载的陈朝海1928年发表的文章《革命青年应该打破的不良观念》",
      },
    ],
  },
  {
    hotId: "KT7dC2i679843",
    img: [
      {
        id: "1.jpg",
        name: "曹顺标在上海的留影",
        content: "1930年，曹顺标在上海的留影",
      },
    ],
  },
  {
    hotId: "GcJ2Eof170954",
    img: [
      {
        id: "1.png",
        name: "晓庄师范旧址",
        content: "晓庄师范旧址",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "1931年陶行知整理出版叶刚烈士的《红叶童话集》",
      },
    ],
  },
  {
    hotId: "qhWlvK682877",
    img: [
      {
        id: "1.png",
        name: "石俊在《乡村教师》期刊创刊号上发表的文章《小朋友的蛇》",
        content:
          "1930年2月，《乡村教师》期刊创刊。这是石俊在该创刊号上发表的文章《小朋友的蛇》",
      },
    ],
  },
  {
    hotId: "tzKXT170115",
    img: [
      {
        id: "1.png",
        name: "郭凤韶的书法作品",
        content: "郭凤韶的书法作品",
      },
      {
        id: "2.png",
        name: "郭凤韶的毕业证书",
        content:
          "1922年，郭凤韶毕业于浙江台属县立女子师范学校。这是她的毕业证书",
      },
      {
        id: "3.jpg",
        name: "郭凤韶在校读书时与同学的合影",
        content:
          "1925年，郭凤韶考入临海女子师范学校。图为郭凤韶（右二）在校读书时与同学的合影",
      },
      {
        id: "4.png",
        name: "郭凤韶创作的《红梅图》《钟馗捉鬼图》",
        content:
          "四一二反革命政变后，郭凤韶创作了《红梅图》《钟馗捉鬼图》，以画明志，表达对革命事业的忠贞",
      },
      {
        id: "5.png",
        name: "郭凤韶穿过的衣服",
        content: "郭凤韶穿过的衣服",
      },
    ],
  },
  {
    hotId: "6Oh5n176098",
    img: [
      {
        id: "1.jpg",
        name: "贵阳达德小学旧址",
        content:
          "1924年，袁咨桐在著名教育家黄齐生创办的达德小学读书。图为贵阳达德小学旧址",
      },
      {
        id: "2.jpg",
        name: "袁咨桐与黄齐生等人的合影",
        content: "1930年，袁咨桐（后排左一）与黄齐生（左二）等人的合影",
      },
      {
        id: "3.jpg",
        name: "袁咨桐小学读书时的日记",
        content:
          "袁咨桐在晓庄师范小学部读书时的日记，1934年收录于《儿童日记作法》一书",
      },
      {
        id: "4.jpg",
        name: "袁咨桐牺牲前的照片",
        content: "袁咨桐牺牲前的照片",
      },
    ],
  },
  {
    hotId: "ooBMI683522",
    img: [
      {
        id: "1.jpg",
        name: "谢纬棨与陶行知同台合演的田汉的《生之意志》话剧剧照",
        content:
          "1929年，陶行知组织成立晓庄剧社，谢纬棨、叶刚、郭凤韶、姚爱兰都是剧社的骨干。图为谢纬棨与陶行知同台合演的田汉的《生之意志》话剧剧照，陶行知出演老父亲，谢纬棨扮演阔少爷",
      },
      {
        id: "2.jpg",
        name: "谢纬棨在田汉改编的话剧《卡门》中扮演革命者卢卡斯的剧照",
        content:
          "晓庄师范被国民党当局查封后，谢纬棨前往上海，参加田汉主持的南国剧社的演出。图为谢纬棨在田汉改编的话剧《卡门》中扮演革命者卢卡斯的剧照",
      },
    ],
  },
  {
    hotId: "vGqxQY684659",
    img: [
      {
        id: "1.png",
        name: "陶行知收集叶刚遗作并编成的《红叶童话集》",
        content:
          "在晓庄师范学习时，叶刚创作了《红叶》《青鸟》等童话，歌颂人民大众的革命精神，讽刺统治阶级的昏暗专制。叶刚牺牲后，陶行知收集并整理了他的9篇遗作，编成《红叶童话集》并亲自作序，于次年出版，以纪念这位年轻战士",
      },
    ],
  },
  {
    hotId: "OUFUm797134",
    img: [
      {
        id: "1.jpg",
        name: "1930年9月《中央日报》关于姚爱兰的相关报道",
        content:
          "为反抗特务抓捕，姚爱兰奋而跳江，仍不幸被捕。国民党《中央日报》歪曲事实，捏造了一则“女共匪投江自尽”的报道。图为1930年9月《中央日报》的相关报道",
      },
    ],
  },
  {
    hotId: "goLuYF682691",
    img: [
      {
        id: "1.png",
        name: "沈云楼读书时写的日记",
        content: "沈云楼在晓庄师范读书时写的日记",
      },
    ],
  },
  {
    hotId: "WkGCOJV692442",
    img: [
      {
        id: "1.jpg",
        name: "中国青年军人联合会第一次代表大会合影",
        content:
          "1925年2月1日，周恩来领导组织的黄埔军校中国青年军人联合会成立，胡秉铎、徐向前和周逸群等被选为负责人。图为中国青年军人联合会第一次代表大会合影，胡秉铎（前排左四）、周逸群（前排左五）",
      },
      {
        id: "2.jpg",
        name: "胡秉铎在狱中写给家人的信",
        content: "1927年，胡秉铎在狱中写给家人的信",
      },
    ],
  },
  {
    hotId: "XeWyX7005157",
    img: [
      {
        id: "1.jpg",
        name: "少年时期的高文华",
        content: "少年时期的高文华",
      },
      {
        id: "2.png",
        name: "高文华在黄埔军校时写给父亲的信",
        content:
          "1926年5月，高文华在黄埔军校时写给父亲的信。信中婉拒了家人给他找的一份高薪而稳定的工作，表示自己是一个革命者，要做“使天下穷苦人将来吃饱穿暖的事”",
      },
      {
        id: "3.png",
        name: "高文华任西北国民革命军第六十七军第九师第二旅中校参谋委任状",
        content:
          "1927年10月，高文华任西北国民革命军第六十七军第九师第二旅中校参谋。这是委任状",
      },
      {
        id: "4.png",
        name: "高文华在狱中写给父亲的信",
        content:
          "1928年3月，高文华在无锡周山浜汤家桥联络工作时被捕，被判9年徒刑。狱中，他潜心研究革命理论，始终保持高昂斗志。这是1929年12月高文华在狱中写给父亲的信",
      },
    ],
  },
  {
    hotId: "64LF6h1685068",
    img: [
      {
        id: "1.png",
        name: "文绍珍写给父母的明信片",
        content: "1926年6月，文绍珍写给父母的明信片",
      },
      {
        id: "2.png",
        name: "文绍珍与党组织失去联系后在岳飞墓的留影上题写的字迹",
        content:
          "1927年四一二反革命政变后，文绍珍与党组织失去联系。他在杭州拜谒岳飞墓的留影上题写了“独自一人！凄凉！惨酷！”和“革命化、纪律化、集体化、国际化”的字迹，表达了内心的苦闷，也彰显出一名共产党员对自身的严格要求",
      },
      {
        id: "3.png",
        name: "文绍珍写给二叔文泽香的信",
        content: "1931年4月，文绍珍写给二叔文泽香的信",
      },
    ],
  },
  {
    hotId: "sRLXyav693452",
    img: [
      {
        id: "1.jpg",
        name: "蓝文胜在军队时使用的马鞭",
        content: "蓝文胜在军队时使用的马鞭",
      },
    ],
  },
  {
    hotId: "9hFscp693978",
    img: [
      {
        id: "1.jpg",
        name: "邓演达在广东陆军小学毕业时的合影",
        content:
          "1909年，邓演达考入广东陆军小学，编为第四期学生，期间加入中国同盟会。图为他在广东陆军小学毕业时的合影",
      },
      {
        id: "2.png",
        name: "邓演达在校期间的留影和毕业证书",
        content:
          "1919年，邓演达毕业于保定陆军军官学校第六期工兵科。这是他在校期间的留影和毕业证书",
      },
      {
        id: "3.png",
        name: "1923年孙中山亲自题赠（赠给）邓演达的照片和手书对联",
        content:
          "1922年6月，陈炯明叛变，邓演达参加了反击叛军的一系列战斗。广州革命政府成立后，他被孙中山授予少将参军之职。这是1923年孙中山亲自题赠（赠给）邓演达的照片和手书对联",
      },
      {
        id: "4.png",
        name: "邓演达与孙中山的通信",
        content: "1923年，邓演达与孙中山的通信",
      },
      {
        id: "5.jpg",
        name: "孙中山视察黄埔军校的合影",
        content:
          "1924年6月，黄埔军校举行开学典礼，孙中山亲自出席主持并发表演说。图为孙中山视察黄埔军校的合影，邓演达（前右一），孙中山（台后立者）",
      },
      {
        id: "6.jpg",
        name: "邓演达和夫人郑立真在广州的合影",
        content: "1926年，邓演达和夫人郑立真在广州的合影",
      },
      {
        id: "7.jpg",
        name: "邓演达北伐时期的留影",
        content:
          "北伐开始后，邓演达被任命为国民革命军总司令部政治部主任，主管北伐军的政治工作。图为他北伐时期的留影",
      },
      {
        id: "8.jpg",
        name: "邓演达与郭沫若、苏联顾问铁罗尼的合影",
        content: "北伐途中，邓演达与郭沫若、苏联顾问铁罗尼的合影",
      },
      {
        id: "9.jpg",
        name: "邓演达在军民联欢大会上讲话的留影",
        content: "1926年10月，北伐军攻克武昌。图为邓演达在军民联欢大会上讲话",
      },
      {
        id: "10.jpg",
        name: "邓演达在检阅学员时的留影",
        content:
          "黄埔军校武汉分校成立，邓演达任代理校长。图为邓演达（前中）在检阅学员",
      },
      {
        id: "11.jpg",
        name: "武昌农民运动讲习所旧址",
        content:
          "1927年3月，邓演达在武昌创立农民运动讲习所，自兼所长，聘请毛泽东为副所长，主持所务。图为武昌农民运动讲习所旧址",
      },
      {
        id: "12.jpg",
        name: "邓演达出席湖北省农民协会第一次代表大会开幕式并讲话的留影",
        content:
          "1927年3月4日，湖北省农民协会第一次代表大会召开。图为协会名誉主席邓演达出席开幕式并讲话",
      },
      {
        id: "13.jpg",
        name: "邓演达在第二次北伐誓师大会誓师台上的留影",
        content:
          "1927年四一二反革命政变后，邓演达力主讨蒋。4月19日，武汉举行第二次北伐誓师大会，邓演达（右二）在誓师台上",
      },
      {
        id: "14.jpg",
        name: "邓演达、宋庆龄、毛泽东等人联名发表的国民党中央委员宣言",
        content:
          "1927年8月1日，邓演达、宋庆龄、毛泽东等人联名发表的国民党中央委员宣言",
      },
      {
        id: "15.jpg",
        name: "邓演达与宋庆龄等人在苏联高加索的合影",
        content:
          "1927年秋，遭到追捕的邓演达抵达莫斯科。图为邓演达（右一）与宋庆龄等人在苏联高加索的合影",
      },
      {
        id: "16.png",
        name: "邓演达前往欧洲各国考察时的护照",
        content: "1929年，邓演达前往欧洲各国考察时的护照",
      },
      {
        id: "17.jpg",
        name: "邓演达与王人达、鲍罗廷在苏联的合影",
        content: "1927年冬，邓演达（中）与王人达（左）、鲍罗廷在苏联",
      },
      {
        id: "18.jpg",
        name: "邓演达和廖承志等人在柏林郊区的合影",
        content: "1928年8月，邓演达（左三）和廖承志（右一）等人在柏林郊区",
      },
      {
        id: "19.jpg",
        name: "邓演达与邱哲在伦敦的合影",
        content: "1929年冬，邓演达（右）与邱哲在伦敦",
      },
      {
        id: "20.jpg",
        name: "邓演达在意大利的留影",
        content: "1930年1月，邓演达在意大利",
      },
      {
        id: "21.jpg",
        name: "邓演达在秘密机关办公室内的留影",
        content:
          "1930年8月，邓演达在上海组织成立中国国民党临时行动委员会，这是农工民主党的前身。图为邓演达在秘密机关办公室内",
      },
      {
        id: "22.jpg",
        name: "邓演达被江苏高等法院第二分院审讯退堂时的情形",
        content:
          "1931年8月，邓演达在上海愚园路愚园坊20号出席江西起义干部训练班结业式作报告时，不幸被捕。图为邓演达（前穿西装者）被江苏高等法院第二分院审讯退堂时的情形",
      },
      {
        id: "23.jpg",
        name: "邓演达被捕后在狱中的留影",
        content: "1931年，邓演达被捕后在狱中的留影",
      },
      {
        id: "24.jpg",
        name: "南京《民生报》关于邓演达被押解至南京的相关报道",
        content:
          "1931年8月，邓演达从上海被押解至南京。这是南京《民生报》的相关报道",
      },
      {
        id: "25.jpg",
        name: "宋庆龄为邓演达殉难30周年的题词",
        content: "1961年11月，宋庆龄为邓演达殉难30周年的题词",
      },
      {
        id: "26.jpg",
        name: "邓演达墓",
        content:
          "1957年11月29日，邓演达遗骸从遇害处迁葬于南京紫金山南麓灵谷寺东侧邓演达烈士陵墓，该陵墓为全国重点文物保护单位。图为邓演达墓，墓碑上题字为何香凝手迹",
      },
      {
        id: "27.png",
        name: "周恩来对邓演达的评价",
        content: "“这人的人格很高尚，对蒋介石始终不低头。”周恩来对邓演达的评价",
      },
      {
        id: "28.jpg",
        name: "毛泽东读《新唐书》时关于邓演达的批注",
        content:
          "“岳飞、文天祥……邓演达……诸辈，以身殉志，不亦伟乎？”毛泽东在读《新唐书》时的批注",
      },
    ],
  },
  {
    hotId: "dN59D759047",
    img: [
      {
        id: "1.png",
        name: "陈继昌给友人的贺年片",
        content: "陈继昌给友人的贺年片",
      },
    ],
  },
  {
    hotId: "th1CP6022452",
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "1926年5月李传夔烈士写给寅弟的信",
      },
    ],
  },
  {
    hotId: "i524eg023501",
    img: [
      {
        id: "1.png",
        name: "蒋宗銮在电报局工作时的笔记本",
        content: "蒋宗銮在电报局工作时的笔记本",
      },
      {
        id: "2.png",
        name: "蒋宗銮的水彩画作品",
        content: "蒋宗銮的水彩画作品",
      },
    ],
  },
  {
    hotId: "HKE1iw760290",
    img: [
      {
        id: "1.jpg",
        name: "战友刘瑞龙来雨花台凭吊冯菊芬时所作诗作《忆菊芬》",
        content:
          "1952年12月，当年战友刘瑞龙来雨花台凭吊冯菊芬时的诗作《忆菊芬》",
      },
    ],
  },
  {
    hotId: "l0gKmL760431",
    img: [
      {
        id: "1.jpg",
        name: "梓生写的七言诗",
        content: "1922年，谭梓生写的七言诗",
      },
    ],
  },
  {
    hotId: "Xayb9hF761183",
    img: [
      {
        id: "1.png",
        name: "刘希雨写给好友的诀别信",
        content: "1931年4月，刘希雨写给好友的诀别信",
      },
    ],
  },
  {
    hotId: "uxwmgF761136",
    img: [
      {
        id: "1.png",
        name: "姜辉麟使用过的算盘",
        content: "姜辉麟使用过的算盘",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "姜辉麟在青年时代所制的葫芦形荷包",
      },
    ],
  },
  {
    hotId: "FjV2Y7762559",
    img: [
      {
        id: "1.png",
        name: "陈仲亭读书时用的箱子",
        content: "陈仲亭在安徽大学读书时用的箱子",
      },
      {
        id: "2.png",
        name: "陈仲亭用过的砚台",
        content: "陈仲亭用过的砚台",
      },
    ],
  },
  {
    hotId: "oGD3kG363754",
    img: [
      {
        id: "1.jpg",
        name: "省港大罢工现场",
        content:
          "1925年6月，罗登贤参与组织了震惊中外的省港大罢工。图为罢工现场",
      },
      {
        id: "2.jpg",
        name: "广州苏维埃政府旧址",
        content:
          "1927年12月，罗登贤参与组织广州起义。在起义后成立的广州苏维埃政府人民外交委员会工作。图为广州苏维埃政府旧址",
      },
      {
        id: "3.jpg",
        name: "周恩来记录手迹",
        content:
          "1928年1月22日，时任广东省委常委罗登贤、黄平向周恩来汇报关于广州起义情况。图为周恩来记录手迹",
      },
      {
        id: "4.jpg",
        name: "罗登贤与妻子周秀珠在上海的合影",
        content: "1929年，罗登贤与妻子周秀珠在上海的合影",
      },
      {
        id: "5.png",
        name: "1931年日本帝国主义发动九一八事变开启了长达14年艰苦卓绝的抗日斗争",
        content:
          "1931年，日本帝国主义发动九一八事变，强占中国东北，中国人民奋起反抗，开启了长达14年艰苦卓绝的抗日斗争",
      },
      {
        id: "6.jpg",
        name: "中共满洲省委机关旧址",
        content:
          "1931年12月，罗登贤任中共满洲省委书记。他组织发动东北人民抵抗日本侵略者，成为党在东北发动抗日斗争的领导者。图为中共满洲省委机关旧址",
      },
      {
        id: "7.png",
        name: "罗登贤发表的《中共满洲省委为日本帝国主义武装占领满洲宣言》",
        content:
          "九一八事变发生的第二天，中共满洲省委召开紧急会议，罗登贤与省委其他同志一起分析事变的性质，讨论确定满洲省委的斗争任务和策略。会后发表《中共满洲省委为日本帝国主义武装占领满洲宣言》",
      },
      {
        id: "8.png",
        name: "罗登贤作出的《关于日本帝国主义武装占据满洲与目前紧急任务的决议》",
        content:
          "1931年9月21日，罗登贤召集满州党的高级干部会议，作出《关于日本帝国主义武装占据满洲与目前紧急任务的决议》，号召组织抗日武装斗争、坚决抗击日本帝国主义",
      },
      {
        id: "9.png",
        name: "罗登贤任中共满洲省委书记时给中央的信",
        content:
          "罗登贤任中共满洲省委书记时给中央的信，汇报了关于士兵工作的情况",
      },
      {
        id: "10.jpg",
        name: "东北抗日联军序列表",
        content:
          "罗登贤先后派出100多名党团员干部赴东北各地独立创建抗日游击队，相继建成的吉林、辽宁、海伦、磐石、海龙、汤源等抗日游击支队，为东北抗日联军的建立奠定了基础。图为东北抗日联军序列表",
      },
      {
        id: "11.png",
        name: "周保中与罗登贤作为接头暗号的一枚四川铜币",
        content:
          "后来曾任东北抗日联军重要领导的周保中，1932年到中共满洲省委工作，与罗登贤的接头暗号为一枚四川铜币",
      },
      {
        id: "12.jpg",
        name: "上海《申报》刊登的关于罗登贤等人被捕的消息",
        content:
          "1932年底，罗登贤被调离东北，到上海担任全国总工会上海执行局党团书记。1933年3月，罗登贤在上海山西路五福弄9号出席全国海员工人会议时，不幸被捕。图为上海《申报》刊登的关于罗登贤等人被捕的消息",
      },
      {
        id: "13.jpg",
        name: "中国民权保障同盟发表的《告中国人民——大家一致起来保护被捕的革命者》",
        content:
          "罗登贤被捕后，以宋庆龄为首的中国民权保障同盟发表了《告中国人民——大家一致起来保护被捕的革命者》一文，高度评价罗登贤反帝爱国的革命精神，呼吁全国人民起来营救他们",
      },
      {
        id: "14.jpg",
        name: "中共中央发表的《八一宣言》",
        content: "1935年，中共中央发表的《八一宣言》中，赞扬罗登贤是民族英雄",
      },
    ],
  },
  {
    hotId: "zCdIaMp395010",
    img: [
      {
        id: "1.jpg",
        name: "周执中与抗日战友在北平的合影",
        content: "1933年春，周执中（左一）与抗日战友在北平的合影",
      },
      {
        id: "2.png",
        name: "周执中写给外甥的回信",
        content:
          "1933年2月，周执中弟弟周健民在热河抗战前线牺牲。周执中回到上海后收到外甥百均的来信，了解到其父母得知健民死于战场后整天以泪洗面。周执中在回信中请外甥代自己多多安慰老人并嘱咐他要坚定抗日救国，完成舅父未竟事业。这是1933年6月，周执中写给外甥的回信",
      },
    ],
  },
  {
    hotId: "IWBQtmD764563",
    img: [
      {
        id: "1.png",
        name: "闵乐山的通缉令",
        content:
          "1930年，中共内江县委遭到破坏，闵乐山因开展农民运动被通缉。这是通缉令",
      },
      {
        id: "2.png",
        name: "闵乐山写给母亲的信",
        content:
          "九一八事变后，闵乐山参加上海青年自愿决死抗日救国团，赴热河前线抗日救亡。这是1933年4月闵乐山在张家口写给母亲的信，信中表达了北上抗战到底的决心",
      },
      {
        id: "3.png",
        name: "闵乐山在狱中写给三叔的明信片",
        content: "1936年，闵乐山在狱中写给三叔的明信片",
      },
    ],
  },
  {
    hotId: "vKcTd765547",
    img: [
      {
        id: "1.png",
        name: "顾景华抄写的刘少奇《论共产党员的修养》片断",
        content: "顾景华抄写的刘少奇《论共产党员的修养》片断",
      },
    ],
  },
  {
    hotId: "E9aBB765304",
    img: [
      {
        id: "1.jpg",
        name: "强博在丹阳工作时的留影",
        content:
          "1940年，强博任中共丹阳县二区区委书记。图为他在丹阳工作时的留影",
      },
      {
        id: "2.jpg",
        name: "江宁县人民政府在强博、焦恭士等烈士牺牲地建立的纪念碑",
        content: "1982年，江宁县人民政府在强博、焦恭士等烈士牺牲地建立的纪念碑",
      },
    ],
  },
  {
    hotId: "P1lUmk477239",
    img: [
      {
        id: "1.jpg",
        name: "焦恭士在学校运动会后与其他获奖同学的合影",
        content: "1931年，焦恭士（右二）在学校运动会后与其他获奖同学的合影",
      },
    ],
  },
  {
    hotId: "5oYVY001210",
    img: [
      {
        id: "1.jpg",
        name: "孙晓梅少年时代的照片",
        content: "孙晓梅出身于书香之家。图为她少年时代的照片",
      },
      {
        id: "2.png",
        name: "孙晓梅写给姨母并转母亲的信",
        content: "1941年5月，孙晓梅写给姨母并转母亲的信",
      },
    ],
  },
  {
    hotId: "cMFNS9k768488",
    img: [
      {
        id: "1.jpg",
        name: "南京市江宁区湖熟镇为纪念陶家齐烈士建立的思陶亭",
        content: "南京市江宁区湖熟镇为纪念陶家齐烈士建立的思陶亭",
      },
    ],
  },
  {
    hotId: "NeDJvwO768047",
    img: [
      {
        id: "1.png",
        name: "邹毅读书时写的作文",
        content: "邹毅读书时写的作文",
      },
      {
        id: "2.png",
        name: "邹毅高中时写的日记",
        content: "邹毅高中时写的日记",
      },
    ],
  },
  {
    hotId: "YC6PyP004802",
    img: [
      {
        id: "1.png",
        name: "邓振询工作时用过的油灯",
        content: "邓振询在中央苏区工作时使用过的油灯",
      },
      {
        id: "2.png",
        name: "邓振询作的《关于苏南工作的报告》",
        content:
          "1942年初，邓振询在中共华中局扩大会议上作《关于苏南工作的报告》，全面介绍了苏南地区的各项工作",
      },
      {
        id: "3.png",
        name: "邓振询担任中共苏皖区委书记时使用的工作笔记本",
        content: "1942年，邓振询担任中共苏皖区委书记时使用的工作笔记本",
      },
      {
        id: "4.jpg",
        name: "邓振询夫妇与战友的合影",
        content: "邓振询夫妇与战友的合影，邓振询（右二）、李坚贞（右一）",
      },
    ],
    "2d": [
      {
        id: "1.jpg",
        name: "",
        content:
          "1936年底，邓振询与一同参加过长征的李坚贞结为革命伴侣。图为1941年邓振询与妻子李坚贞的合影",
      },
    ],
  },
  {
    hotId: "dNGQm771672",
    img: [
      {
        id: "1.jpg",
        name: "1938年春新四军部分领导人在皖南的合影",
        content:
          "1938年春，新四军部分领导人在皖南合影，陈毅（左一）、项英（左二）、袁国平（左三）、粟裕（左六）、叶挺（左七）",
      },
      {
        id: "2.jpg",
        name: "1939年7月新四军第一次党代表大会主席团合影",
        content:
          "1939年7月，新四军第一次党代表大会主席团合影，陈毅（前排左一）、项英（前排左三）、袁国平（前排左二）、周子昆（前排左四）",
      },
      {
        id: "3.jpg",
        name: "皖南事变三烈士墓地",
        content: "皖南事变三烈士墓地",
      },
    ],
  },
  {
    hotId: "W47DTm708221",
    img: [
      {
        id: "1.jpg",
        name: "洗心亭",
        content:
          "1935年，吕惠生任无为县政府建设科长时，有个豪绅为了霸占一块公田修建私宅，拿出200银元贿赂吕惠生。吕惠生将贿款公之于众，并用这笔钱在当地锦绣溪畔建起了一座凉亭，取名“洗心亭”，以表明心志。图为洗心亭",
      },
      {
        id: "2.jpg",
        name: "吕惠生在干训班讲话提纲中提出“廉”的要求",
        content:
          "吕惠生在一次干训班讲话提纲中，就如何做好财粮工作，专门对干部提出“廉”的要求",
      },
      {
        id: "3.jpg",
        name: "“惠生堤”竣工典礼",
        content:
          "1944年5月6日，吕惠生领导完成了皖江抗日根据地最大的水利工程——无为长江大堤黄丝滩江堤的建设，该江堤被皖中行政公署命名为“惠生堤”。图为“惠生堤”竣工典礼（中骑马者为吕惠生）",
      },
      {
        id: "4.png",
        name: "吕惠生日记中黄丝滩工程总结报告",
        content:
          "吕惠生在日记中记录了黄丝滩工程总结报告，其中载明该工程的详细经过和每一项支出情况",
      },
      {
        id: "5.jpg",
        name: "吕惠生日记摘录",
        content:
          "七七事变后，吕惠生投入抗日救亡运动。这是他1943年8月2日的日记摘录",
      },
      {
        id: "6.jpg",
        name: "吕惠生妻子与子女的合影",
        content:
          "吕惠生参加新四军后，先后将3个孩子送入新四军队伍中。图为1950年吕惠生妻子与子女的合影",
      },
      {
        id: "7.png",
        name: "吕惠生为抗议国民党军队进攻无为抗日根据地起草的《通电》手稿",
        content:
          "1943年，吕惠生为抗议国民党军队进攻无为抗日根据地起草的《通电》手稿",
      },
    ],
  },
  {
    hotId: "DTsDBH1772512",
    img: [
      {
        id: "1.jpg",
        name: "中国人民抗日军事政治大学旧址",
        content: "1937年，高波进入中国人民抗日军事政治大学学习。图为该校旧址",
      },
      {
        id: "2.jpg",
        name: "高波在大学期间与战友的合影",
        content: "高波（中）在中国人民抗日军事政治大学学习期间与战友的合影",
      },
      {
        id: "3.png",
        name: "高波写给妻子成波的信",
        content:
          "1946年7月，高波给妻子成波写信，嘱咐她要坚强、独立地工作和生活。",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "高波：“当歌汉苏武”",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "高波：“当歌汉苏武”",
      },
    ],
  },
  {
    hotId: "HViSp773455",
    img: [
      {
        id: "1.png",
        name: "秦明摄于南京的照片",
        content: "1935年，秦明摄于南京的照片",
      },
      {
        id: "2.jpg",
        name: "秦明与妻子党瑶池的新婚合影",
        content: "1938年，秦明与妻子党瑶池的新婚合影",
      },
      {
        id: "3.png",
        name: "秦明任教期间阅读的书籍",
        content:
          "1940年9月，秦明受党组织委派，从甘肃回到延安，在延安行政学院任教。这是秦明任教期间阅读的书籍",
      },
    ],
  },
  {
    hotId: "6TDwBVt774758",
    img: [
      {
        id: "1.jpg",
        name: "北京一二九抗日爱国运动的游行场景",
        content:
          "1935年，刘亚生在北京大学读书时，参加了一二九运动。图为这次抗日爱国运动的游行场景",
      },
      {
        id: "2.jpg",
        name: "三五九旅在绥德师范学校召开会议中全体军政干部的合影",
        content:
          "1941年，三五九旅在绥德师范学校召开会议。图为会议中全体军政干部的合影，刘亚生（前排左四）",
      },
      {
        id: "3.jpg",
        name: "刘亚生与湖南人民抗日救国军政治部南下人员的合影",
        content:
          "1944年，刘亚生随三五九旅南下抗日，此时三五九旅的番号为湖南人民抗日救国军。图为刘亚生（前排左一）与湖南人民抗日救国军政治部南下人员的合影",
      },
    ],
  },
  {
    hotId: "HPzZDK726331",
    img: [
      {
        id: "1.jpg",
        name: "朱克靖与北伐军部分政工人员在南昌的合影",
        content:
          "1926年底，朱克靖与北伐军部分政工人员在南昌的合影，朱克靖（前排左三）、郭沫若（前排左二）、李富春（前排左四）、李一氓（后排左二）、林伯渠（后排左三）",
      },
      {
        id: "2.jpg",
        name: "周恩来与新四军领导人在云岭的合影",
        content:
          "1939年，朱克靖等人向视察皖南云岭新四军军部的周恩来汇报军部工作。这是周恩来与新四军领导人在云岭的合影，左起：陈毅、粟裕、傅秋涛、周恩来、朱克靖、叶挺",
      },
      {
        id: "3.jpg",
        name: "朱克靖与南昌起义部分人员的合影",
        content:
          "1940年，朱克靖与南昌起义部分人员的合影，朱克靖（右九）、陈毅（右一）、粟裕（右四）、叶挺（右六）",
      },
      {
        id: "4.jpg",
        name: "朱克靖为纪念新四军成立六周年撰写的《回忆与感想》",
        content:
          "1943年11月，朱克靖为纪念新四军成立六周年撰写的《回忆与感想》，记述了他自南昌起义后，十余年的革命斗争经历",
      },
      {
        id: "5.jpg",
        name: "朱克靖与妻子、女儿在山东莒县的合影",
        content: "1946年，朱克靖与妻子、女儿在山东莒县的合影",
      },
      {
        id: "6.jpg",
        name: "朱克靖被捕后的照片",
        content: "朱克靖被捕后的照片",
      },
    ],
  },
  {
    hotId: "WrD0Lz9729451",
    img: [
      {
        id: "1.jpg",
        name: "晋夫与战友的合影",
        content: "1945年8月，晋夫（左）与战友的合影",
      },
      {
        id: "2.png",
        name: "晋夫在延安整风期间的日记",
        content: "晋夫在延安整风期间的日记",
      },
    ],
  },
  {
    hotId: "ZIj8S734785",
    img: [
      {
        id: "1.png",
        name: "孔繁蕤写给大哥、二哥的信",
        content: "1942年10月，孔繁蕤写给大哥、二哥的信",
      },
      {
        id: "2.png",
        name: "丁行从事情报工作时使用的日记本",
        content: "丁行从事情报工作时使用的日记本",
      },
      {
        id: "3.png",
        name: "朱建国中学时期的日记",
        content: "朱建国中学时期的日记《读了72烈士广州殉难之后》",
      },
      {
        id: "4.jpg",
        name: "朱建国与妻子高慧麟的新婚合影",
        content: "朱建国与妻子高慧麟的新婚合影",
      },
      {
        id: "5.jpg",
        name: "赵良璋在国民党空军部队的留影",
        content: "赵良璋在国民党空军部队的留影",
      },
      {
        id: "6.jpg",
        name: "赵良璋与妻子蒋平仲的合影",
        content: "赵良璋与妻子蒋平仲的合影",
      },
      {
        id: "7.jpg",
        name: "赵良璋与友人在重庆的合影",
        content: "1945年7月，赵良璋与友人在重庆的合影",
      },
      {
        id: "8.jpg",
        name: "孔繁蕤戎装照",
        content: "孔繁蕤戎装照",
      },
      {
        id: "9.jpg",
        name: "谢士炎与妻子朱彦元的结婚照",
        content: "谢士炎与妻子朱彦元的结婚照",
      },
      {
        id: "10.jpg",
        name: "丁行在狱中写给好友张汉惺的信",
        content: "丁行在狱中写给好友张汉惺的信",
      },
      {
        id: "11.jpg",
        name: "丁行狱中写给妻子蒲洛宇的信",
        content: "1948年8月，丁行狱中写给妻子蒲洛宇的信",
      },
      {
        id: "12.jpg",
        name: "谢士炎亲笔填写的《入党志愿书》",
        content: "1947年2月，谢士炎亲笔填写的《入党志愿书》",
      },
      {
        id: "13.jpg",
        name: "《世界日报》报道的北平五烈士被杀害的消息",
        content: "1948年10月，《世界日报》报道北平五烈士被杀害的消息",
      },
      {
        id: "14.png",
        name: "朱建国在狱中写给妻弟陈鹏的信",
        content: "朱建国在狱中写给妻弟陈鹏的信",
      },
      {
        id: "15.png",
        name: "赵良璋临刑前写给同狱难友的诀别信",
        content: "赵良璋临刑前写给同狱难友朱铁华等人的诀别信",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "1948年谢士炎烈士所作狱中诗手稿",
      },
    ],
  },
  {
    hotId: "v5IPFyf776055",
    img: [
      {
        id: "1.jpg",
        name: "徐楚光在扬州医院治伤时在瘦西湖的留影",
        content: "1944年，徐楚光在扬州医院治伤时在瘦西湖的留影",
      },
      {
        id: "2.jpg",
        name: "《解放日报》关于徐楚光从事情报工作的报道",
        content:
          "1945年8月，徐楚光带领情报系统成员在南京成功策反汪伪警卫第三师起义。图为当时《解放日报》的报道",
      },
      {
        id: "3.jpg",
        name: "“建国号”飞机及驾驶员黄哲夫",
        content:
          "1945年春，徐楚光参与策反汪精卫“建国号”座机起义。图为“建国号”飞机及驾驶员黄哲夫",
      },
      {
        id: "4.jpg",
        name: "徐楚光妻子朱剑平和孩子的合影",
        content: "1948年3月，徐楚光妻子朱剑平和孩子的合影",
      },
    ],
  },
  {
    hotId: "wNc0jM155352",
    img: [
      {
        id: "1.jpg",
        name: "策反孙良诚部投诚情况表",
        content: "策反孙良诚部投诚情况表",
      },
      {
        id: "2.jpg",
        name: "周镐在军统局重庆本部任职时的照片",
        content:
          "1942年，中共地下党员徐楚光利用同乡和校友的关系策反周镐，在党组织的安排下，周镐被批准为中共特别党员。图为周镐在军统局重庆本部任职时的照片，上面文字为他亲笔所写",
      },
      {
        id: "3.jpg",
        name: "周镐与妻子吴雪亚在南京玄武湖的合影",
        content: "周镐与妻子吴雪亚在南京玄武湖的合影",
      },
      {
        id: "4.jpg",
        name: "《复兴日报》上刊载的由周镐亲自起草的南京指挥部胜字一号布告",
        content:
          "1945年8月16日，日军宣布投降的第二天，周镐参与接管南京的行动。图为《复兴日报》上刊载的由周镐亲自起草的南京指挥部胜字一号布告",
      },
      {
        id: "5.png",
        name: "周镐日记",
        content: "周镐日记（1948.09.23-1949.01.04）",
      },
      {
        id: "6.png",
        name: "周镐使用的书箱",
        content: "周镐使用的书箱",
      },
      {
        id: "7.png",
        name: "周镐使用的砚台",
        content: "周镐使用的砚台",
      },
      {
        id: "8.png",
        name: "王清瀚在西北军时俄国顾问赠送的毛毯",
        content: "王清瀚在西北军时，俄国顾问赠送的毛毯",
      },
      {
        id: "9.png",
        name: "祝元福从事情报工作时使用的商会路证",
        content: "祝元福从事秘密情报策反工作时，在蒋管区活动时使用的商会路证",
      },
    ],
  },
  {
    hotId: "F84nJ2170067",
    img: [
      {
        id: "1.jpg",
        name: "卢志英与妻子张育民在南昌的合影",
        content: "1934年，卢志英与妻子张育民在南昌的合影",
      },
      {
        id: "2.jpg",
        name: "中央特科联系人莫雄的回忆录",
        content:
          "中央特科联系人莫雄的回忆录，记录了卢志英等人获取国民党第五次“围剿”中央苏区计划的经过",
      },
      {
        id: "3.png",
        name: "卢志英使用的臂章",
        content: "抗日战争爆发后，卢志英在苏北组织抗日游击队。这是他使用的臂章",
      },
      {
        id: "4.jpg",
        name: "卢志英与妻子张育民、儿子卢大容的合影",
        content: "1945年，卢志英与妻子张育民、儿子卢大容的合影",
      },
      {
        id: "5.jpg",
        name: "卢志英与儿子卢大容的合影",
        content: "卢志英与儿子卢大容的合影",
      },
      {
        id: "6.png",
        name: "卢大容撰写的《和爸爸一起坐牢的日子》",
        content: "卢大容撰写的《和爸爸一起坐牢的日子》",
      },
    ],
  },
  {
    hotId: "RHgDE778406",
    img: [
      {
        id: "1.jpg",
        name: "杨斌与陈丕显在上海的合影",
        content: "1941年，杨斌（右）与陈丕显在上海的合影",
      },
      {
        id: "2.png",
        name: "杨斌化名陈月亭签订的“保之药房”合同",
        content:
          "1943年，杨斌在苏北白蒲镇以“保之药房”的名义建立了党的地下工作站。这是他化名陈月亭签订的“保之药房”合同",
      },
      {
        id: "3.jpg",
        name: "杨斌与任天石在狱中口述，由难友艾星华记录转呈陈毅、陈丕显的信",
        content:
          "1947年5月，杨斌与任天石在狱中口述，由难友艾星华记录转呈陈毅、陈丕显的信",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "杨斌：抱着至死不变的决心",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "杨斌：抱着至死不变的决心",
      },
    ],
  },
  {
    hotId: "g1B6DKn778198",
    img: [
      {
        id: "1.png",
        name: "上海中国医学院《毕业纪念刊》收录的任天石毕业论文",
        content: "上海中国医学院《毕业纪念刊》收录的任天石毕业论文",
      },
      {
        id: "2.png",
        name: "任天石使用过的医用剪刀和开的药方",
        content:
          "任天石从上海中国医学院毕业后，在家乡挂牌行医。这是他使用过的医用剪刀和开的药方",
      },
      {
        id: "3.png",
        name: "任天石发表的文章《一年来的民抗》",
        content:
          "1941年1月15日，任天石发表于《江南》第三卷第六、七期合刊上的《一年来的民抗》",
      },
      {
        id: "4.jpg",
        name: "任天石与妻子陈行之的合影",
        content: "任天石与妻子陈行之的合影",
      },
      {
        id: "5.jpg",
        name: "任天石与华中十地委工作人员的合影",
        content: "1946年，任天石（中）与华中十地委工作人员的合影",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "任天石：弃医从戎赴国难",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "任天石：弃医从戎赴国难",
      },
    ],
  },
  {
    hotId: "l8DtZb779966",
    img: [
      {
        id: "1.jpg",
        name: "黄叔雷在金陵大学读书时的留影",
        content: "黄叔雷在金陵大学读书时的留影",
      },
      {
        id: "2.png",
        name: "黄叔雷使用过的怀表",
        content: "黄叔雷使用过的法国制造的怀表",
      },
      {
        id: "3.png",
        name: "黄叔雷在狱中写给妻子的信",
        content: "1947年，黄叔雷在狱中写给妻子的信",
      },
    ],
  },
  {
    hotId: "Qn3X8RO779550",
    img: [
      {
        id: "1.jpg",
        name: "孟琇焘与友人的合影",
        content: "1938年，孟琇焘（左）与友人的合影",
      },
      {
        id: "2.jpg",
        name: "孟琇焘与妻子张聪敏的合影",
        content: "孟琇焘与妻子张聪敏的合影",
      },
    ],
  },
  // {
  //   hotId: 'rkCb1S198158',
  //   img: [{
  //       id: '1.jpg',
  //       name: '《文萃》公开出版发行时的招牌',
  //       content: '《文萃》公开出版发行时的招牌'
  //     },
  //     {
  //       id: '2.png',
  //       name: '《文萃》周刊第一期',
  //       content: '1945年10月9日出版的《文萃》周刊第一期'
  //     },
  //     {
  //       id: '3.png',
  //       name: '《文萃》丛刊第一期',
  //       content: '1947年3月，《文萃》周刊被国民党当局查封，为了迷惑敌人，主编陈子涛改16开本为32开本，以丛刊形式秘密发行。这是3月30日出版的《文萃》丛刊第一期'
  //     },
  //     {
  //       id: '4.png',
  //       name: '《文萃》杂志中的漫画',
  //       content: '《文萃》杂志中的漫画“美国大炮和中国泥路”“道高一尺、魔高一丈”'
  //     },
  //     {
  //       id: '5.png',
  //       name: '陈子涛读过的《毛泽东印象》《论联合政府》',
  //       content: '陈子涛读过的《毛泽东印象》《论联合政府》'
  //     },
  //     {
  //       id: '6.jpg',
  //       name: '《文萃》杂志社工作人员在上海龙华的合影',
  //       content: '《文萃》杂志社工作人员在上海龙华的合影。陈子涛（前排右二）、吴承德（后排左一）、黎澍（后排左二）'
  //     },
  //     {
  //       id: '7.jpg',
  //       name: '骆何民与妻子费枚华、孩子在福州的合影',
  //       content: '1944年，骆何民与妻子费枚华、孩子在福州的合影'
  //     },
  //   ],
  //   article: [{
  //       id: '1 (1).png',
  //       name: '',
  //       content: '陈子涛——以笔为枪呼唤光明'
  //     },
  //     {
  //       id: '1 (2).png',
  //       name: '',
  //       content: '陈子涛——以笔为枪呼唤光明'
  //     },
  //   ],
  //   '2d': [{
  //     id: '1.png',
  //     name: '',
  //     content: '1948年12月27日骆何民烈士在狱中写给妻子的绝笔信'
  //   }, ],
  // },
  {
    hotId: "kgwopi382611",
    img: [
      {
        id: "1.jpg",
        name: "《文萃》公开出版发行时的招牌",
        content: "《文萃》公开出版发行时的招牌",
      },
      {
        id: "2.png",
        name: "《文萃》周刊第一期",
        content: "1945年10月9日出版的《文萃》周刊第一期",
      },
      {
        id: "3.png",
        name: "《文萃》丛刊第一期",
        content:
          "1947年3月，《文萃》周刊被国民党当局查封，为了迷惑敌人，主编陈子涛改16开本为32开本，以丛刊形式秘密发行。这是3月30日出版的《文萃》丛刊第一期",
      },
      {
        id: "4.png",
        name: "《文萃》杂志中的漫画",
        content: "《文萃》杂志中的漫画“美国大炮和中国泥路”“道高一尺、魔高一丈”",
      },
      {
        id: "5.png",
        name: "陈子涛读过的《毛泽东印象》《论联合政府》",
        content: "陈子涛读过的《毛泽东印象》《论联合政府》",
      },
      {
        id: "6.jpg",
        name: "《文萃》杂志社工作人员在上海龙华的合影",
        content:
          "《文萃》杂志社工作人员在上海龙华的合影。陈子涛（前排右二）、吴承德（后排左一）、黎澍（后排左二）",
      },
    ],
    article: [
      {
        id: "1 (1).png",
        name: "",
        content: "陈子涛：以笔为枪呼唤光明",
      },
      {
        id: "1 (2).png",
        name: "",
        content: "陈子涛：以笔为枪呼唤光明",
      },
    ],
  },
  {
    hotId: "1lBt3F381558",
    img: [
      {
        id: "1.jpg",
        name: "《文萃》公开出版发行时的招牌",
        content: "《文萃》公开出版发行时的招牌",
      },
      {
        id: "2.png",
        name: "《文萃》周刊第一期",
        content: "1945年10月9日出版的《文萃》周刊第一期",
      },
      {
        id: "3.png",
        name: "《文萃》丛刊第一期",
        content:
          "1947年3月，《文萃》周刊被国民党当局查封，为了迷惑敌人，主编陈子涛改16开本为32开本，以丛刊形式秘密发行。这是3月30日出版的《文萃》丛刊第一期",
      },
      {
        id: "4.png",
        name: "《文萃》杂志中的漫画",
        content: "《文萃》杂志中的漫画“美国大炮和中国泥路”“道高一尺、魔高一丈”",
      },
      {
        id: "5.jpg",
        name: "骆何民与妻子费枚华、孩子在福州的合影",
        content: "1944年，骆何民与妻子费枚华、孩子在福州的合影",
      },
    ],
    "2d": [
      {
        id: "1.png",
        name: "",
        content: "1948年12月27日骆何民烈士在狱中写给妻子的绝笔信",
      },
    ],
  },
  {
    hotId: "mAO2IM226199",
    img: [
      {
        id: "1.jpg",
        name: "成贻宾和家人的合影",
        content: "成贻宾（后排左一）和家人的合影",
      },
      {
        id: "2.jpg",
        name: "成贻宾在中央大学的学籍表",
        content:
          "成贻宾中学毕业时报考清华大学、英士大学和中央大学，被三所学校同时录取。这是他在中央大学的学籍表",
      },
      {
        id: "3.png",
        name: "成贻宾在中央大学的学生证和校徽",
        content: "成贻宾在中央大学的学生证和校徽",
      },
      {
        id: "4.png",
        name: "成贻宾写给未婚妻彭毓芬的信",
        content:
          "1944年，成贻宾写给未婚妻彭毓芬的信。信中阐述了“新生十大信条”，表达了他对新生活的理想和憧憬",
      },
    ],
  },
  {
    hotId: "XnF8mt781630",
    img: [
      {
        id: "1.jpg",
        name: "程履绎身着学士服的留影",
        content: "程履绎身着学士服的留影",
      },
      {
        id: "2.png",
        name: "中央大学学生为纪念四一烈士制作的纪念画册",
        content: "中央大学学生为纪念四一烈士制作的纪念画册《凶手，你逃不了！》",
      },
    ],
  },
  {
    hotId: "QKjSWN781470",
    img: [
      {
        id: "1.jpg",
        name: "陈祝三抢救受伤学生时驾驶的汽车",
        content: "陈祝三抢救受伤学生时驾驶的汽车",
      },
    ],
  },
  {
    hotId: "ydNwgz799893",
    img: [
      {
        id: "1.jpg",
        name: "人民解放军百万雄师开启渡江作战",
        content: "1949年4月20日晚8时，人民解放军百万雄师开始了渡江作战",
      },
    ],
  },
  {
    hotId: "cDeyg067588",
    img: [
      {
        id: "1.jpg",
        name: "解放南京",
        content:
          "1949年4月23日，胜利渡江的人民解放军解放国民党反动统治的中心南京，标志着国民党22年反动统治的崩溃",
      },
      {
        id: "2.jpg",
        name: "毛泽东诗《七律·人民解放军占领南京》",
        content: "毛泽东诗《七律·人民解放军占领南京》",
      },
    ],
  },
  // {
  //   hotId: '',
  //   img: [
  //     {id: '',name: '',content: ''},
  // ]
  // },
];
